(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWelephant_atlas_", frames: [[1532,3287,140,442],[1674,3287,140,442],[1640,395,236,440],[1532,2845,236,440],[1644,2444,261,387],[1658,837,261,387],[1648,1578,261,387],[1644,2055,261,387],[1378,1183,278,393],[1640,0,278,393],[1364,2450,278,393],[1364,2055,278,393],[756,3097,322,385],[756,1936,322,385],[756,2323,322,385],[756,2710,322,385],[1016,872,338,389],[1043,0,338,389],[754,1545,338,389],[1016,481,338,389],[377,3051,377,390],[377,3443,377,390],[377,2659,377,390],[377,2267,377,390],[377,824,375,479],[377,1305,375,479],[666,0,375,479],[377,1786,375,479],[0,3229,375,479],[0,824,375,479],[0,2267,375,479],[0,2748,375,479],[0,1786,375,479],[0,1305,375,479],[1002,3484,244,490],[756,3484,244,490],[754,1013,260,530],[754,481,260,530],[1080,1936,282,394],[1094,1263,282,394],[1080,2728,282,394],[1364,1659,282,394],[1080,2332,282,394],[1356,787,282,394],[1248,3124,282,394],[1356,391,282,394],[1248,3520,282,394],[0,0,664,410],[0,412,664,410],[1094,1659,208,208],[0,3710,176,176]]}
];


// symbols:



(lib.ElephantFrontLegBack0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.ElephantFrontLegBack0002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.ElephantFrontLeg0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.ElephantFrontLeg0002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0010001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0010002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0010003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0010004 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0020001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0020002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0020003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0020004 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0030001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0030002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0030003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0030004 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0040001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0040002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0040003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0040004 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0050001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0050002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0050003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0050004 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110003 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110005 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110007 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110009 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110011 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110017 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110019 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110021 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHead_0110023 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHindLegBack0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHindLegBack0002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHindLeg0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();



(lib.ElephantHindLeg0002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(37);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(38);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0160 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(39);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0163 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(40);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0166 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(41);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0169 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(42);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0184 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(43);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0187 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(44);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0190 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(45);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTail0193 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(46);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTorso0001 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(47);
}).prototype = p = new cjs.Sprite();



(lib.ElephantTorso0002 = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(48);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(49);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWelephant_atlas_"];
	this.gotoAndStop(50);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.Tween80dsvcr = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AADgGIABAAIgHANIAGgNg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,-0.6,0.8,1.4);


(lib.Tween7gfgf9 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AADgGIABAAIgHANIAGgNg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.4,-0.6,0.8,1.4);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6.5,1,1).p("AFYEcQgUgBgVgKQichGgkkKQgNhXAChiQACg9AEgkQANhhAxhLQA8hcB0g+QCohZCCBSQAhAVAUAQQAdAXARAZQALAQAkAvQAiAxAQAzQASA3gBA9QgBAvgMA2QgFAZgIA1QgHApgGASQgLAigGAYQgJAkgCAhQAFA3gLArQgGAWgOAZQgPAagLADQgDAAgEABQgDAMgEAOQgcBlAFBPQACAnAQAzQAJAdArBEQibBHirgvQhAANgNgmIAAAAIAHjBQgFgRgEgnQgEgngFgTQgFgOgGgNgAFWEYQABACABACAlSlVQBABLAAB8QAABCABAsQgGBPgRBLQgFAZgGAwQgHAlgRAQQgGA8AABCQAAAqADALQAKAzAEAYQAJAyAUAYQARAUgCAPQgBAOgnAWQgoAWh7gPQAAg5gih+QgIAPgIAQQgOAegTAjQgKAVgFANQgKAggBAEQgGAVACAPQAFAmgPAHQh7hIh7AJQgKACAIgZQAHgUAZg4QBEiVA2ihQAGgTAGgPQgEgBgDgCQgMgIABgZQAEgWAAgBQAAgEARhwQgDiEAAgRQAAiPBAhRQA5hJBUAAQBTgBA6BFg");
	this.shape.setTransform(-10,72.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.legGlow, new cjs.Rectangle(-105.3,-2.9,184.1,171.2), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.ElephantMouth_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AhdAoQgpgcgfgeQgcgbAAgHQAAg3A8gLQBDgNB0AzQAkAJA2A8QA2A6AAAeQAAATgIAJQgPARgxAAQhkAAhzhSg");
	this.shape.setTransform(19.4,12.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantMouth_001, new cjs.Rectangle(0,0,38.8,24.4), null);


(lib.ElephantHead_011 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 5
	this.instance = new lib.ElephantHead_0110001();
	this.instance.parent = this;
	this.instance.setTransform(-11,-3,0.5,0.5);

	this.instance_1 = new lib.ElephantHead_0110003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-11,-3,0.5,0.5);

	this.instance_2 = new lib.ElephantHead_0110005();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-11,-3,0.5,0.5);

	this.instance_3 = new lib.ElephantHead_0110007();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-11,-3,0.5,0.5);

	this.instance_4 = new lib.ElephantHead_0110009();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-11,-3,0.5,0.5);

	this.instance_5 = new lib.ElephantHead_0110011();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-11,-3,0.5,0.5);

	this.instance_6 = new lib.ElephantHead_0110017();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-11,-3,0.5,0.5);

	this.instance_7 = new lib.ElephantHead_0110019();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-11,-3,0.5,0.5);

	this.instance_8 = new lib.ElephantHead_0110021();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-11,-3,0.5,0.5);

	this.instance_9 = new lib.ElephantHead_0110023();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-11,-3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_5}]},2).to({state:[{t:this.instance_6}]},6).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance_8}]},2).to({state:[{t:this.instance_9}]},2).to({state:[{t:this.instance_9}]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-24,-8,200.5,244.6);


(lib.ElephantEye_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgOAAQAAgFAFgGQAGgEADAAQAPAAAAAPQAAAQgPAAQgOAAAAgQg");
	this.shape.setTransform(6.6,4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AgRA1QgegEgDgsQgBgsAzgLQAZgGAPAPQAOAQgFAaQgFAbgSAOQgPALgUAAIgIAAgAAFgYQgFAGAAAGQAAAPAPAAQAPAAAAgPQAAgQgPAAQgEAAgGAEg");
	this.shape_1.setTransform(5.1,5.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantEye_001, new cjs.Rectangle(0,0,10.2,10.6), null);


(lib.elephant_trunkMud_006 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{mud:0,soap:33,clean:45});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_33 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(33).call(this.frame_33).wait(12).call(this.frame_45).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("Ah3AsQgOgWAggWIABgIQADgOANAAQAKAAAIACIAcgMIALgIQAIgIAGAAQAKABAEACIAGACIABAAQAEgGAGgFQAHgHAHABQAHAAAHADIACACQANgRAJAAQATABAGAbQAEgEAIAAQASABAAALQAAAGgJAHQgLAJgQAAIgDAAIgBABQhBA1g2AWQgXAJgRACQghgKgMgTg");
	this.shape.setTransform(12.4,7.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,24.9,14.7);


(lib.elephant_trunkMud_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":57});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_57 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(12).call(this.frame_57).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhZCZQgFgEgDgFIgHgEQgTgKAAgPQAAgMAJgIQAIgGAHAAQAHAAAHACQADgIAHgHQAIgIAHAAIASADQADgHAFgGQAIgOAOAAIAKABQACgBAGgOQAFgOAKgEIAFgBIgGgDQgLgHABgGQAAgKALgFQgEgFAAgHQAAgQASgLIAFgCQAGgHACABIAAgBQgVgfAmgpIACgDIACgJIgCgGIAAgDQAhgEAQAeIABABIgBAEQAIAPgFAMQgBABAAABQAAABAAAAQABABAAAAQABABAAAAQgDADADACIgCAEIABADQgCAKAEAKIACABIgCAEQgKAqglA4IgqA+IgBAEQABAWgxAZQgGABgTAGIgVAFQgQAAgKgJg");
	this.shape.setTransform(12.4,16.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},33).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,24.7,32.5);


(lib.elephant_trunkMud_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":33,"clean":45});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_33 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(33).call(this.frame_33).wait(12).call(this.frame_45).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhaBKQgIgEgQgNIgWgSQgQgNgWgfQgXgfgLgmQgMgnEQA0IAAAAQAHAEADAGIAKABQAQAAARAGIARAHQAOgHAEAAIAQAAIASADIAIACIAMAFIACABIALgGIAAAAQAFARgGAQIgfAYQgGACgLAIIgJAIIgXARQgSAPAEAHQgdAFgXADQgjAJgeAAQgtAAgogSg");
	this.shape.setTransform(21,9.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,42,18.3);


(lib.elephant_trunkMud_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":33,"clean":45});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_33 = function() {
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(33).call(this.frame_33).wait(12).call(this.frame_45).wait(12));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhdBvQgggbgYhVQgRg/gGhCIACg7QgEgaAjAFQAlAFgBAaQAAADgCADQgBADAAAFQAGAFACAEIAAAIQAAAEgDAJQAAAMAZAMQAaAMAAAZQAAAFgEAUQAAAAAAABQAAAAAAABQAAAAAAAAQABABAAAAIACAAQAeACANAWQAHAKABAMQAIgFARAFQAGABAEAJIABAGQAEgEAFgBQATgCADAEQACAEABAHQASgCAGAIQABACABAJIAAAIIgBAJQAWgCALACQALACAJAJQAFAGABAIQAAAGgBAHIAFAAQAIAAAHADQgNAUgTAUQgYAaghATQgiAUgoAHIgRABQgwgkgmhBg");
	this.shape.setTransform(17.3,21.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},21).wait(36));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,34.6,42.4);


(lib.elephant_trunkGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#F9C446").ss(6,1,1).p("Ai3k+QAPAugNAjQgJAaAFAeQAHAoAgANQAMAFAIA3QAHAwgCAWQgGBPALBEQAAABAAACQAGAhAJAcQAXBEAnAWIAAABQACABABADQAAABABABQADABADABQAgALAYAMQAKAAAMABQA5AFASgHQABAAABAAIAPgEQAFgCAFAAQAJgHAXgIQANgFATgHQALgEAQgLQAMgKAFAAQgBgIADgGIAEgIQALgsAYAVQAMAKAMAVQALAKAVAOQARAKAEAHQAFAKgjAOQgjAPgMgDQgDAAgBAAIgGADIgxApQgBAAAAABQgBAAAAABIgBAAQgnAegUACQgDABgCACIAAABQg0AbhHADQgZACgWgFQgFAAgHAAIgOABQgFAAgFAAQgHgBgHAAQgIAAgJgBQgFAAgEgBQhIgFg+g5IAAAAQgCgCgCgCQgqgpgWgjQAAAAAAgBQgHgLgFgKQgCgDgBgDQgQglgNgwQgGgWgPg8QABgBABgBQgKgngFgoQgLhIADgiQgNglACgOQgFgxAAgEQgDhXAGhRQAMifBvBdQAyAqARA4g");
	this.shape.setTransform(37.8,45.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.elephant_trunkGlow, new cjs.Rectangle(-3,-3,81.6,96.3), null);


(lib.elephant_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ANcA/QAAADACAYQgBAbgKAVQggBAh5AAQhVAAg9gGQgPAGgaAAQgcAAgGgNQAAgCAAgCQgIgBgHgCQgFAEgJAAQgdAAgOgQQgIgLAAgJQAAgUALgQQALgPAOgFQABAAAAAAQgCABgDAAQgEACgEACQgBABgBABQgKAHgZgHQgRgEgBgKQABgGABgCQgDgCgBgCQgFAJgKgDQgSgFgGgMQgDgHACgGQADgMAJgIQAJgIAKAAQAEAAADABQADgMAFgJQAEgGAVgZQARgTBHAmIADAJQACACADADQAAgEAAgCQC6hGCsAmQALAsAAA0gAG2BdQACAAACAAQASgTAPgWQgBAAgBgCQABABACAAQAGgJAEgMAjJgVQAXAeAAAhQAAASAAADQgDANgOAKQgmAciDAAQg+AAgYgdQgRgFgGgMQgEgIACgGQADgMAKgJQACgBACgBQAFgMALgTQAUgmAUgaQAUgbBJgIQBKgHAZA8QgBAMAKANgAouhiQAHAPAOA2QgCAfAAAIQANAnAAAkQAAAhgDAKQgKAigoADQg7AKg+gBQgPAIggAAQgcAAgGgNQAAgBAAgBQgIgBgIgBQgCAAgCAAQgEABgEAAQgdAAgOgQQgJgLAAgJQAAgUAMgQQABgCABgBQAFgTARgfQACgEACgEQAHgZAHgVQAJgeAGggQAFghAQgwQARgwBBADQA2ACBJBcIAEAIIAAABIAMAXIAJAu");
	this.shape.setTransform(86.6,18.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.elephant_footGlow, new cjs.Rectangle(-2.5,-5.1,178.4,46.4), null);


(lib.Elephant_blink = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#5D8888").s().p("AgwAvQgLgLgFgNQA4AXBJgXQgFANgLALQgVAUgcAAQgbAAgVgUgAhEAAQAAgbAUgTQAVgUAbAAQAcAAAVAUQAUATAAAbQgygbhXAbg");
	this.shape.setTransform(6.9,6.7);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#5D8888").s().p("AgwAvQgUgTAAgcQAAgbAUgTQAVgUAbAAQAcAAAVAUQAUATAAAbQAAAcgUATQgVAUgcAAQgbAAgVgUg");
	this.shape_1.setTransform(6.9,6.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape}]},27).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape}]},1).to({state:[]},1).wait(20));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.elephant_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFCC00").ss(6.2,1,1).p("ALSgrIAAAAQAAABAAAAIAAgBQjcCkkyBgQkwBgjzgkQjygkhKieQhJidAYhnQAYhnAUgEQAUgFA7AKQA6AJCSA4QBbAjBfgBQBJgBBggYQA2gOBugfQBigYBLgBQBYgCBeAqQBXAnBKBEQAsApAgAsg");
	this.shape.setTransform(72.4,28.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.elephant_backGlow, new cjs.Rectangle(-2.9,-3,150.6,63.5), null);


(lib.earGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(6,1,1).p("ADTnlQgsgkgQgKQgxgggqgCQhfgGhtA3Qg3AcgmAeQhjBCAdBDQAdBEAfBqQAhBrAGAfQAGAmAJBdQAJBeAEAaQADAMAFAtQArCTAzBWQAaAsATgGQAPgHAagqQALgJAFgIQAPAUAWgEQAFgBAGgFQAjgHAcg/QAOghAGgUQAWgEASgpQAMgPAAgHQAAgEAJgVQAIgWAAgIQgIgzAAgCQAAgCAHgOQAFgMADgGQADABAFABQAVAMAPgDQALgCAHgIQAEgCAEgEQANgLAAgFQAAhOgSgmQgNgXgJgSQABgDACgEQASgCAAgXIAChNIgNhjQAAgpgCgHQAKg7gEgbQgGghgXgwQgag0gWgKg");
	this.shape.setTransform(31.4,56.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.earGlow, new cjs.Rectangle(-3,-3,68.9,119.4), null);


(lib.blueglowtrunk = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("Ai3k+QAPAugNAjQgJAaAFAeQAHAoAgANQAMAFAIA3QAHAwgCAWQgGBPALBEQAAABAAACQAGAhAJAcQAXBEAnAWIAAABQACABABADQAAABABABQADABADABQAgALAYAMQAKAAAMABQA5AFASgHQABAAABAAIAPgEQAFgCAFAAQAJgHAXgIQANgFATgHQALgEAQgLQAMgKAFAAQgBgIADgGIAEgIQALgsAYAVQAMAKAMAVQALAKAVAOQARAKAEAHQAFAKgjAOQgjAPgMgDQgDAAgBAAIgGADIgxApQgBAAAAABQgBAAAAABIgBAAQgnAegUACQgDABgCACIAAABQg0AbhHADQgZACgWgFQgFAAgHAAIgOABQgFAAgFAAQgHgBgHAAQgIAAgJgBQgFAAgEgBQhIgFg+g5IAAAAQgCgCgCgCQgqgpgWgjQAAAAAAgBQgHgLgFgKQgCgDgBgDQgQglgNgwQgGgWgPg8QABgBABgBQgKgngFgoQgLhIADgiQgNglACgOQgFgxAAgEQgDhXAGhRQAMifBvBdQAyAqARA4g");
	this.shape.setTransform(37.8,45.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowtrunk, new cjs.Rectangle(-3,-3,81.6,96.3), null);


(lib.blueglowlegs = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6.5,1,1).p("AFYEcQgUgBgVgKQichGgkkKQgNhXAChiQACg9AEgkQANhhAxhLQA8hcB0g+QCohZCCBSQAhAVAUAQQAdAXARAZQALAQAkAvQAiAxAQAzQASA3gBA9QgBAvgMA2QgFAZgIA1QgHApgGASQgLAigGAYQgJAkgCAhQAFA3gLArQgGAWgOAZQgPAagLADQgDAAgEABQgDAMgEAOQgcBlAFBPQACAnAQAzQAJAdArBEQibBHirgvQhAANgNgmIAAAAIAHjBQgFgRgEgnQgEgngFgTQgFgOgGgNgAFWEYQABACABACAlSlVQBABLAAB8QAABCABAsQgGBPgRBLQgFAZgGAwQgHAlgRAQQgGA8AABCQAAAqADALQAKAzAEAYQAJAyAUAYQARAUgCAPQgBAOgnAWQgoAWh7gPQAAg5gih+QgIAPgIAQQgOAegTAjQgKAVgFANQgKAggBAEQgGAVACAPQAFAmgPAHQh7hIh7AJQgKACAIgZQAHgUAZg4QBEiVA2ihQAGgTAGgPQgEgBgDgCQgMgIABgZQAEgWAAgBQAAgEARhwQgDiEAAgRQAAiPBAhRQA5hJBUAAQBTgBA6BFg");
	this.shape.setTransform(-10,72.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowlegs, new cjs.Rectangle(-105.3,-2.9,184.1,171.2), null);


(lib.blueglowear = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6,1,1).p("ADTnlQgsgkgQgKQgxgggqgCQhfgGhtA3Qg3AcgmAeQhjBCAdBDQAdBEAfBqQAhBrAGAfQAGAmAJBdQAJBeAEAaQADAMAFAtQArCTAzBWQAaAsATgGQAPgHAagqQALgJAFgIQAPAUAWgEQAFgBAGgFQAjgHAcg/QAOghAGgUQAWgEASgpQAMgPAAgHQAAgEAJgVQAIgWAAgIQgIgzAAgCQAAgCAHgOQAFgMADgGQADABAFABQAVAMAPgDQALgCAHgIQAEgCAEgEQANgLAAgFQAAhOgSgmQgNgXgJgSQABgDACgEQASgCAAgXIAChNIgNhjQAAgpgCgHQAKg7gEgbQgGghgXgwQgag0gWgKg");
	this.shape.setTransform(31.4,56.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowear, new cjs.Rectangle(-3,-3,68.9,119.4), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(6.2,1,1).p("ALSgrIAAAAQAAABAAAAIAAgBQjcCkkyBgQkwBgjzgkQjygkhKieQhJidAYhnQAYhnAUgEQAUgFA7AKQA6AJCSA4QBbAjBfgBQBJgBBggYQA2gOBugfQBigYBLgBQBYgCBeAqQBXAnBKBEQAsApAgAsg");
	this.shape.setTransform(72.4,28.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(-2.9,-3,150.6,63.5), null);


(lib.Trunkpt1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("Ah9B8IAEgBQA1AdA5AKQgLAMgRAAQghAAg1gygAhaBMQAvAhAaAPQgqgPgfghgAhzAHQAAAAAAAAQAAAAABAAQAAAAABAAQAAAAABAAQBWBQB1AFIABABIgLABQh0AAhQhXgAiBhPQgMgJALgBQByBbCWADIACACIgPAAQiLAAhvhWgAhvitIADAAQA9AkBDAPIADABQhLgDg7gxg");
	this.shape.setTransform(14.4,45.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AiqEfQgRg0ADgSIgFg9QgDhkAGhbQAMi2AtgqQCOiEBoBZQBoBYgpCpQgpCogiBsQgiBrhwABIgCAAQhvAAgQg0g");
	this.shape_1.setTransform(19.1,31.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.Trunkpt1, new cjs.Rectangle(0,-2.4,38.3,67.8), null);


(lib.TrunkEnd = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AAMBFQgqgFgKgKQgIgIgEgRIgDgbQABgLAMgTQAJgOAHgIQAjglAMAiQAGARAAAcQAFAPANAaQALAUAAAJQgBAIgUAAIgXgBg");
	this.shape.setTransform(5.7,10.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.TrunkEnd, new cjs.Rectangle(0.2,3.3,11.2,14.1), null);


(lib.ElephantTuskPart = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AhkC2IABgDQAHgNAPgFQBNgsBNAKIAEABQhLAKhmAtIgEgBgAhWCAQATgOAVgHQBRghBMAkIABACQh4gnhsBZQAHgRAXgRgAiDBJQASggAhgOQBQgbBLAcIACABQiRgvhICPQgDAGgGAEQgBgfATgfgACIAAIgZgGQACAVgCAZIgCADQAAgbgFgYQhMgShTALQBUgaBKAZQgIgtgVgtQAAAAAAAAQAAAAAAAAQABAAABAAQAAgBABAAQAbAsAHAxIAZAMQgPhjhRhRIAAAAQBeBTAKBkIADACIADACIgFgCQAEAxgPA1QAAAAAAAAQAAABAAAAQAAAAgBAAQAAAAAAAAQALg4gIgygAhHBPQgFgBAFgCQBqgZBYAyIABACQhVglhuANg");
	this.shape.setTransform(15.9,22);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AihCnQgDgUAAg0QAKhUAZhPQAwigBHAAQA1AAAzBPQAvBIAUBdQAMA3gcAkQgaAhgrAAQhnAAgeAtIgUAeQgPAOgfAAQgeAAgIg+g");
	this.shape_1.setTransform(16.5,22.9);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantTuskPart, new cjs.Rectangle(0,0,33,45.8), null);


(lib.ElephantTusk = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFCC").s().p("Aj+DDQgOAAgFgFQgCgCAAgFQAAgFA1gUQBAgYAVgOQAZgPA+gxQAlgeAigqQApgyAAgYQAAgdAmglQAsgsA6AAQAqAAAUAcQAMASAAAVQAAAMgKATIgKATQAAAQgbAqQghAzgzAtQiRCCjPAAQgIAAgngGg");
	this.shape.setTransform(27.6,20.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantTusk, new cjs.Rectangle(0,0,55.3,40.2), null);


(lib.ElephantTail = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{loopback:157});

	// Layer 3
	this.instance = new lib.ElephantTail0001();
	this.instance.parent = this;
	this.instance.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_1 = new lib.ElephantTail0160();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_2 = new lib.ElephantTail0163();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_3 = new lib.ElephantTail0166();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_4 = new lib.ElephantTail0169();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_5 = new lib.ElephantTail0184();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_6 = new lib.ElephantTail0187();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_7 = new lib.ElephantTail0190();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-5.5,-2.9,0.5,0.5);

	this.instance_8 = new lib.ElephantTail0193();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-5.5,-2.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},159).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_3}]},3).to({state:[{t:this.instance_4}]},3).to({state:[{t:this.instance_3}]},6).to({state:[{t:this.instance_2}]},3).to({state:[{t:this.instance_1}]},3).to({state:[{t:this.instance_5}]},3).to({state:[{t:this.instance_6}]},3).to({state:[{t:this.instance_7}]},3).to({state:[{t:this.instance_8}]},3).to({state:[{t:this.instance}]},3).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.5,-2.9,141,197);


(lib.ElephantHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,"clean":2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:209,"final":210,final_loop:211});

	// Layer 4
	this.instance = new lib.ElephantHindLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.1,0.5,0.5);

	this.instance_1 = new lib.ElephantHindLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(0.1,0.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-4.3,0,126.4,268.6);


(lib.ElephantHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 7
	this.instance = new lib.ElephantHindLeg0001();
	this.instance.parent = this;
	this.instance.setTransform(-1.9,16.6,0.5,0.5);

	this.instance_1 = new lib.ElephantHindLeg0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.9,16.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-22.3,5.9,167,290.8);


(lib.ElephantFrontLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"final":210,"final_loop":211});

	// Layer 6
	this.instance = new lib.ElephantFrontLegBack0001();
	this.instance.parent = this;
	this.instance.setTransform(-1.5,-4.9,0.5,0.5);

	this.instance_1 = new lib.ElephantFrontLegBack0002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-1.5,-4.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[]},206).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1.5,-5,112.2,242.9);


(lib.ElephantFace = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AEMFCIAJgGQggAAgmgGIgEgCQAsAGAngHQAOgLAKgNQgbAEglgFQgVAHgUAFQAAAAAAAAQgBAAAAAAQAAgBgBAAQAAAAAAgBIAhgLIgDAAQgBAAAAAAQgBAAAAgBQgBAAAAAAQAAgBgBAAIAKABQBJggAshIQAAAAAAAAQABgBAAAAQAAAAABAAQAAgBABAAQghBLhIAfQAjgBAggKQAQgZAKgcIADgBQgFAcgMAWQAVgGATgMQgRAYghAJQgLAPgNALQAxgMApggQACgDADgCQgkA2hLAFIgPAIgAD9DlQBGgnAohLIABAAQgVBLhSAmIgFABIgDAAgAmJgbIADgDQAagSAgACQBvgLA+BZIABADQhZhliSAngAlDh+IgigMIADAAQCPAUB9BNIABABQhugxiAglgAk5kNQgGgBAGgDQAfgHAXAPQAAAAAAABQAAAAABAAQAAAAAAABQAAAAAAABQgXgBgggGgAkelAIACgBQAlgHAhAPIAAABQgigBgmgHg");
	this.shape.setTransform(47.1,78.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AAZJMQjWgrg0hZQg0hYgYgTQgYgTAOAFQANAGgtgXQgtgXgiA1QgjA1gNgXQgNgYATg1QATg1AEhFQAEhFArh/QAqiAAlh4QAlh4BPhWQBPhWDZgcQDZgcAuBtQAtBsAXBQQAWBPAHARQAHAQAjDJQAjDIhcDSQhRC4j3AAQgjAAgmgDg");
	this.shape_1.setTransform(51.8,59.1);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantFace, new cjs.Rectangle(2.6,0,98.5,118.3), null);


(lib.ElephantEarPart = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AAsEGQgHgMgXhYIgRhMQgNgugKgbQgRgwgKgZQgRgsgXgcQgQgSggg+Qgeg6gBgHQAAgeA2AmQAkAbBJBEIAsBFQAZAoANAhQAYA4AYAuIAeA4QAVAsAABZQAAAGgOANQgQANgIAAQhFAAgVgdg");
	this.shape.setTransform(17.3,29.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantEarPart, new cjs.Rectangle(0,0,34.5,58.2), null);


(lib.ElephantEar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("Aj6HpQgqhZgUiTIACg3QAAgZAJhaQAIhZAAgmQAAgegRhqQgQhrgThEQgUhECAguQAygXBFgRQCJgjBuAWQAwAJA0AmQAPAMAtApQAXANAUA2QARAxAAAgQAAAbgbA8QgcA7AABbQAAAhgSAgQgJAQgJAKIALAqQAKAsAAARQAAATgJAVQgPAdgbAAQgUAAgbgSQgIgGgSgQQAAA4gFAbIAAAGQAAASggAvQglA2ggAAQgJAAgPgMIgBABIgGASQgHAYgnAlQgoAmgRAAQgdAAgMgYIgBgBQg3A1gXAEIgDAAQgWAAgUgrgAAuF0IABABIAGgEIgHADg");
	this.shape.setTransform(32.8,46.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantEar, new cjs.Rectangle(-2,-6.6,69.8,106.4), null);


(lib.EartPart2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AA7CMQgghogKgZQgag9hLgzQgfgWgMgQQgRgYAAglQAAgMAKgIQANgJAXAAQApAABDAzQAyAnAMAQQAiAtAVAYQADAFAAAxIAPBxIgDBYQAAAdgYAAQgbAAgghag");
	this.shape.setTransform(14.5,23);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.EartPart2, new cjs.Rectangle(0,0,29.1,46), null);


(lib.EarPart6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AA5GPQgthWgKgNQgMgRgShAQgShBAAggIgEgaIgEgaQAAgEADgHQADgIAAgEQAAgegEgeQgFgeAAguQAAgsgOgwQgWhJhRjXQBgDAAZAgQAXAeAFAaQALAVAHAiQAGAhAAAbIgGBfQAAAIAFAoQAAArAWAmQAkA7AMAhIAfBXQAUA1AaAgIAHgKQAFgHAGgDQAFADAEAJQADAHAAADQAAAMgaAVQgaAVgRAAQgNAAgkhHg");
	this.shape.setTransform(9.9,28);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.EarPart6, new cjs.Rectangle(-7.5,-19,34.9,94.1), null);


(lib.EarPart5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AgeFtIgGgEQgQgHgEgaIgCgkIAKhLQAKhHAAg8IgChHQgDg6AAgcQAAgLgIg7QgJg/gFgRIgZhOQgTg9AAgIQAAgUAeAuQARAdAlBDQAxBaAwC8QAmCXAAAaQAAAYgbA9QgkBRguAAQgPAAgQgKg");
	this.shape.setTransform(11,37.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.EarPart5, new cjs.Rectangle(0,0.1,22,75), null);


(lib.EarPart4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AAOFuQgDgRgOhmQgEgbgVhYQgVhSAAgFQgFgdAAgIQAAgFgOgxQgOgyAAgQQgRh0AAgcIgqhMQgqhLAAgfIABgGIABAAQAaABALAZQAGAPAGAdQAKANAOAbIAXApQA6BYA/BGQAoAsA0BsQA4B1AAA8QAAAEgFAEQgJAGgTADQgCAIgIASQgIARAAACIAJA9QAAAJgKAZQgJAYAAAFQAAALgaAaQgcAdgTAAQgUAAgQhQg");
	this.shape.setTransform(18.4,44.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.EarPart4, new cjs.Rectangle(0,0,36.8,89.2), null);


(lib.EarPart3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("ADGB2QgQgtgBguIACAAQAVAlgDA5QAAgBgBAAQAAAAgBgBQAAAAAAgBQgBAAAAAAgACiBNQgZhjhGgzIAAgEQBhA2AABrQgCgCAAgFgAAFAMQgGhAgOhCIAAgCQAgBDgKBGIgCgFgAg5gFQgQgyggghIAAgBQAvAPAEBHIgDgCgAh/guQgfgbgrgJQAAgFADAAQA4gDASAuIgBAAIgCgCg");
	this.shape.setTransform(6.1,-5.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AEXCcQgFgegLgWQgIgBhdgeQhcgdgRgBQgRgBhCgxQhCgxjnAVQEfjECNBOQCNBOAfA4QAgA3AAAHQAAAHAPAcQANAggHAdQgBAJgEAIIgBACQgGAMgLAEQgGACgHAAQgHAAgEgUg");
	this.shape_1.setTransform(-0.1,2.5);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(1));

}).prototype = getMCSymbolPrototype(lib.EarPart3, new cjs.Rectangle(-32.9,-17.3,65.7,37.4), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(45.6,4.1,0.326,0.326,-155.4,0,0,11.3,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_2, new cjs.Rectangle(27.1,-14.9,46.8,40.7), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.ElephantFace_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.EarPart3();
	this.instance.parent = this;
	this.instance.setTransform(31,26.5,0.607,0.623,0,135,-45);
	this.instance.shadow = new cjs.Shadow("#000000",0,0,2);
	this.instance.filters = [new cjs.ColorFilter(0.89, 0.89, 0.89, 1, 0, 0, 0, 0)];
	this.instance.cache(-35,-19,70,41);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.instance_1 = new lib.ElephantTuskPart();
	this.instance_1.parent = this;
	this.instance_1.setTransform(49,92.4,1.027,1.078,0,-15.5,164.5,16.2,22.9);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.ElephantTusk();
	this.instance_2.parent = this;
	this.instance_2.setTransform(66.7,120.4,0.922,0.922,0,6.3,-173.7,28.1,20.6);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,2,4);

	this.instance_3 = new lib.ElephantFace();
	this.instance_3.parent = this;
	this.instance_3.setTransform(45.4,56.8,0.922,0.922,0,0,180,51.8,61.6);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.ElephantFace_001, new cjs.Rectangle(-5,-5,106.9,156.8), null);


(lib.elephant_trunkMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":100,glowclean:101,glowclean_loop:102,"final":103,"final_loop":104});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ADGGSIgHgEIgTgTIgIAAIgJgFIgPABIgdgMQgNgGgLACIgGgDQgPADgRgHQgSgJgQgJIgHgEQgRgJgLgOIgKgDIgFgFQgrgmgggyIg/hgIABgBIgDgCIACADIAAAAIgKgSIABgCIgGgMQgEgPgBgNIgFgVIgBgEIACgFIgEgaQACgEAAgFQgBgfAGgfIgCgMIABgBQAMgeAMgbQAGgFAFgHIASgdIA3hWIARgWQAYAoAjAZIAGADQgCAJgEAIQgHARgLADQAHAFABAGIAAAKQgBAFgDABIgVAOIADAJQABACAAAEQgBAJgJAGQgGAEgWAIIgCACIgEABIABAEIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAJQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbAMAGAFQAIAGAAAKIgBAGIgFAIIAUAQQADACAAAFIgBAKQgBAEgDACIAHAHQAEAEgCADIgCAZIAJADQADABACACQAHAHgBAKQgBAIgKAbQACACADABIACAAQAUgGAFAFQADAEABASIAAABQAGAHAFAKQADAGAAAEQACAHgBAFIgFAHIABABIABAAQATABADADQAFAFgFAVIAAACQAAACACACQAbgKAJAAQAKgBAGAGQADADABADIADAJIAYgDQAEgBAEAEIAGAHQADAFgCAJQAKgFAQAIQAJAFAIAHIABAAQASAAAEAEQAFAFgFAUIgBACIADAFQAOAagFAQgAAbkdIgBgBQgggLgfgQIgBgBIgCAAQgDgCgDAAIgCgBIAKgLQAggmAlglQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKQAGAHABAGQABAFgDAHIgFAKIgJAKg");
	this.shape.setTransform(20.6,14.7);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(9.3,9.2,0.5,0.5,-82.5,0,0,50.5,5.2);

	this.instance_1 = new lib.elephant_trunkGlow();
	this.instance_1.parent = this;
	this.instance_1.setTransform(41.6,7.1,1,1,45,0,0,37.8,45.1);

	this.glow = new lib.blueglowtrunk();
	this.glow.parent = this;
	this.glow.setTransform(41.6,7.1,1,1,45,0,0,37.8,45.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_1}]},2).to({state:[]},2).to({state:[{t:this.instance}]},7).to({state:[{t:this.instance}]},87).to({state:[{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},121).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.4,-25.7,40.4,81);


(lib.elephant_earMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":150,"glowclean":151,"glowclean_loop":152,"final":153,"final_loop":154});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABlGoIgBgCIgHgDQgGgMgJgLIgDgEIgEgBIgEgFQgLAHgJAJIgEADQgoAHgagjIgZghIgXhDQgDgIgEgFIgDgIQgFgCgDgEIgDgFIgEgBIAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAAAIAAAAIgIgBQgHgQgLgNIgBgBQgQgdgIgfQgIglAQgbIAAgYIgCgGIgEgEIgBgEIgBAAIgBgBIAAgBQgVATghgEIgFgBIgGgGIgFgDIgDgEIgDAAQgcgYAKgpQACgJgBgOIAMgqIAAgJIAMgOIAAgDQABhMgNhHIACgIQANglACgyIgCgDIgEAAQASgigHguIAAADIgBgKIgDgNIAPABQA4AKgKA2IAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAJAUQAGANAAAVIgCAVIASgBQArABAAAbQgNAjgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgDACIgEAFIgEABQgDAEgHAAIgLAAQgNgPgIgRgAhxDvIAAAAIABAAgAjnAuIAAgCIAEACg");
	this.shape.setTransform(30.8,45.6);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(31.4,59.3,0.668,0.668,43.7,0,0,50.6,5.2);

	this.instance_1 = new lib.left_over_bubbles("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(27.5,67.5,0.532,0.532,64.7,0,0,35.9,10.8);

	this.instance_2 = new lib.earGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.glow = new lib.blueglowear();
	this.glow.parent = this;
	this.glow.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},8).to({state:[{t:this.instance_1},{t:this.instance}]},136).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).to({state:[]},113).wait(38));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(6,0,49.8,91.2);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.TrunkPt3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AhNC9QgLgQgNgfIgKgcQgNgzgIg1QgSh9AQgaQBSh/BoAjQA2ASAkAtIgBANIgJCKQgGBaAMBNQgCAYgYAYQgXAZghAMQgYAIgVAAQgzAAglg0g");
	var mask_graphics_1 = new cjs.Graphics().p("AhNC9QgLgQgNgfIgKgcQgNgzgIg1QgSh9AQgaQBSh/BoAjQA2ASAkAtIgBANIgJCKQgGBaAMBNQgCAYgYAYQgXAZghAMQgYAIgVAAQgzAAglg0g");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:13.5,y:21.4}).wait(1).to({graphics:mask_graphics_1,x:13.5,y:21.4}).wait(1));

	// Layer 3
	this.instance = new lib.elephant_trunkMud_002();
	this.instance.parent = this;
	this.instance.setTransform(7.4,33.5,1,1,0,0,0,8.6,17.6);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AgsA/IgBgBQBMADA1gnQgQAnhNAAIgjgCgAhTgGIACAAQBKALBHgJIACACQglALgjAAQgoAAglgPgAhThAIACAAQBKALBHgJIACABQglANgjAAQgoAAglgQg");
	this.shape.setTransform(10.3,30.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AhNC9QgLgQgNgfIgKgcQgNgzgIg1QgSh9AQgaQBSh/BoAjQA2ASAkAtIgBANIgJCKQgGBaAMBNQgCAYgYAYQgXAZghAMQgYAIgVAAQgzAAglg0g");
	this.shape_1.setTransform(13.5,21.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-0.7,-2.7,28.5,48.3);


(lib.Trunkpt2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AhdCLQgbgQAKgoQALguAvgsQAugtAHgWQAHgWASgVQATgWAUgEQA4gOgIBoIABAAQgOBAgyBBQgiAsgrARQgWAJgRAAQgPAAgMgHg");
	var mask_graphics_1 = new cjs.Graphics().p("AhdCLQgbgQAKgoQALguAvgsQAugtAHgWQAHgWASgVQATgWAUgEQA4gOgIBoIABAAQgOBAgyBBQgiAsgrARQgWAJgRAAQgPAAgMgHg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:57.1,y:50.3}).wait(1).to({graphics:mask_graphics_1,x:57.1,y:50.3}).wait(1));

	// Layer 2
	this.instance = new lib.elephant_trunkMud_005();
	this.instance.parent = this;
	this.instance.setTransform(56.6,51.5,1,1,0,0,0,12.3,16.2);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AhdCLQgbgQAKgoQALguAvgsQAugtAHgWQAHgWASgVQATgWAUgEQA4gOgIBoIABAAQgOBAgyBBQgiAsgrARQgWAJgRAAQgPAAgMgHg");
	this.shape.setTransform(57.1,50.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(45.7,35.8,22.8,29.2);


(lib.TrunkPart4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AgOBVQhWgHhIhFQAAglAbgbQA2g4B9ArQB0AoATAkQANAYgaAUQgZAUgfAKQgSAFglAAQgaAAghgCg");
	var mask_graphics_1 = new cjs.Graphics().p("AgOBVQhWgHhIhFQAAglAbgbQA2g4B9ArQB0AoATAkQANAYgaAUQgZAUgfAKQgSAFglAAQgaAAghgCg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:17.3,y:8.8}).wait(1).to({graphics:mask_graphics_1,x:17.3,y:8.8}).wait(1));

	// Layer 2
	this.instance = new lib.elephant_trunkMud_004();
	this.instance.parent = this;
	this.instance.setTransform(13.9,13.3,1,1,0,0,0,20.9,9.2);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AgOBVQhWgHhIhFQAAglAbgbQA2g4B9ArQB0AoATAkQANAYgaAUQgZAUgfAKQgSAFglAAQgaAAghgCg");
	this.shape.setTransform(17.3,8.8);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,34.7,17.5);


(lib.ElephantTrunkPart6 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AgVC1QhHhGgXg1QgTgrgPg2IgYheQAmgoAygRQBjgkA+BtQAHA5AQAvQAaBMAsAaQAJAFgGAYQgGAagTAVQghAjgzAAQgmAAgugTg");
	var mask_graphics_1 = new cjs.Graphics().p("AgVC1QhHhGgXg1QgTgrgPg2IgYheQAmgoAygRQBjgkA+BtQAHA5AQAvQAaBMAsAaQAJAFgGAYQgGAagTAVQghAjgzAAQgmAAgugTg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:17.4,y:13.4}).wait(1).to({graphics:mask_graphics_1,x:17.4,y:13.4}).wait(1));

	// Layer 4
	this.instance = new lib.elephant_trunkMud_003();
	this.instance.parent = this;
	this.instance.setTransform(16.4,18.6,1,1,0,0,0,17.3,21.2);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AAHBZQAtgSAlgdQgNAmhEAKIgBgBgAgZA3IgCgBQBDgGAvgvQAAAAABAAQAAgBAAAAQABAAAAAAQABAAAAAAQgiA3hGAAIgLAAgAg3AdQA1gWAsglIACgBQgdAxhEANQgBAAAAAAQAAAAgBgBQAAAAAAAAQAAAAAAgBgAhGgRQAjgKAggQQAQgHAPgKQgJALgLAIQgeAWgvADIgBgBgAhYhIIgBgBQA3gCAzgOQgeAVgoAAQgRAAgSgEg");
	this.shape.setTransform(13.1,19.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

	// Layer 1
	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#699999").s().p("AgVC1QhHhGgXg1QgTgrgPg2IgYheQAmgoAygRQBjgkA+BtQAHA5AQAvQAaBMAsAaQAJAFgGAYQgGAagTAVQghAjgzAAQgmAAgugTg");
	this.shape_1.setTransform(17.4,13.4);

	this.timeline.addTween(cjs.Tween.get(this.shape_1).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,-6.5,34.9,39.9);


(lib.ElephantTrunkPart4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AgrBIQgfgHgSgQQgigfA1gtQAKgIAdgLIAlgNQBDgZAaAZQAJAJABAMQABALgGAFIhIA6QgwAlgWAAIgCgBg");
	var mask_graphics_1 = new cjs.Graphics().p("AgrBIQgfgHgSgQQgigfA1gtQAKgIAdgLIAlgNQBDgZAaAZQAJAJABAMQABALgGAFIhIA6QgwAlgWAAIgCgBg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:10.6,y:7.3}).wait(1).to({graphics:mask_graphics_1,x:10.6,y:7.3}).wait(1));

	// Layer 2
	this.instance = new lib.elephant_trunkMud_006();
	this.instance.parent = this;
	this.instance.setTransform(13.7,7.9,1,1,0,0,0,12.5,7.3);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#699999").s().p("AgrBIQgfgHgSgQQgigfA1gtQAKgIAdgLIAlgNQBDgZAaAZQAJAJABAMQABALgGAFIhIA6QgwAlgWAAIgCgBg");
	this.shape.setTransform(10.6,7.3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,21.2,14.5);


(lib.ElephantTrunk = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Top Trunk
	this.instance = new lib.Trunkpt1("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(17.2,32.6,1.149,1,0,0,0,15.8,32.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

	// Lower Trunk
	this.instance_1 = new lib.TrunkPt3("synched",0);
	this.instance_1.parent = this;
	this.instance_1.setTransform(19.9,81.3,1,1,0,0,0,18.3,32.4);

	this.instance_2 = new lib.ElephantTrunkPart6("synched",0);
	this.instance_2.parent = this;
	this.instance_2.setTransform(20.8,97.2,1,1,0,0,0,17.4,16.6);

	this.instance_3 = new lib.TrunkPart4("synched",0);
	this.instance_3.parent = this;
	this.instance_3.setTransform(35.4,110.8,1,1,0,0,0,17.3,8.8);

	this.instance_4 = new lib.Trunkpt2("synched",0);
	this.instance_4.parent = this;
	this.instance_4.setTransform(37.4,113.4,0.998,0.998,49.9,0,0,50.2,62.1);

	this.instance_5 = new lib.ElephantTrunkPart4("synched",0);
	this.instance_5.parent = this;
	this.instance_5.setTransform(66.7,108.6,1,1,0,0,0,10.6,7.2);

	this.instance_6 = new lib.TrunkEnd("synched",0);
	this.instance_6.parent = this;
	this.instance_6.setTransform(75.3,102.7,1,1,-30,0,0,2.5,11.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-1,-2.4,86.6,122.2);


(lib.ElephantTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 6
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(37.4,38.8,1.084,1.084,171.8,0,0,35.9,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-15.1,51.4,1.084,1.084,-98.2,0,0,36.4,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(75.6,13.9,1.084,1.084,-158.2,0,0,35.9,11.2);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(3.5,17.6,1.084,1.084,171.8,0,0,35.9,11.2);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(125.4,25.2,1.084,1.084,-121.4,0,0,36,11.2);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-49.1,13.3,0.961,0.961,75,0,0,35.6,11.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(43));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ElephantTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":150,"glowclean":151,"glowclean_loop":152,"final":153,"final_loop":154});

	// Layer 6
	this.instance = new lib.elephant_backGlow();
	this.instance.parent = this;
	this.instance.setTransform(197.4,55.4,1.772,1.772,3.5,0,0,72.4,28.8);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(280));

	// Layer 5
	this.instance_1 = new lib.ElephantTorso0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-2.4,-1.4,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_sparse();
	this.instance_2.parent = this;
	this.instance_2.setTransform(138.5,35.2,1,1,0,0,0,47.6,10.1);

	this.instance_3 = new lib.left_over_bubbles_few();
	this.instance_3.parent = this;
	this.instance_3.setTransform(124.4,21.5,1,1,0,0,0,47.8,9.3);

	this.instance_4 = new lib.left_over_bubbles_2();
	this.instance_4.parent = this;
	this.instance_4.setTransform(159.5,30.8,1,1,0,0,0,48.9,4.8);

	this.instance_5 = new lib.left_over_bubbles();
	this.instance_5.parent = this;
	this.instance_5.setTransform(212.4,28.6,1,1,0,0,0,50.6,5.2);

	this.instance_6 = new lib.ElephantTorso0002();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-2.4,-1.4,0.5,0.5);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(197.4,55.4,1.772,1.772,3.5,0,0,72.4,28.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},8).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2}]},136).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.glow}]},1).to({state:[{t:this.instance_6}]},2).to({state:[]},2).wait(131));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.4,-1.4,332,205);


(lib.ElephantHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":129});

	// Layer 6
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-72.1,165.8,1.102,1.102,0,-113.3,66.7,36.5,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-56.5,149.9,1.102,1.102,0,-49.9,130.1,36.2,11.3);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-215.2,193.6,1.102,1.102,0,-57.4,122.6,35.9,11.2);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-232.7,94.8,1.102,1.102,0,-49.9,130.1,36.2,11.2);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-189.3,82.8,1.102,1.102,0,-49.9,130.1,35.8,11.3);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-162.3,103.4,1.102,1.102,0,-4.9,175.1,35.6,11.2);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-179.1,127.7,1.102,1.102,0,-4.9,175.1,35.9,11.4);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-226.1,149.7,1.102,1.102,0,72.6,-107.4,35.9,11.3);

	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-237,125.3,1.102,1.102,0,85.1,-94.9,36,11.2);

	this.instance_9 = new lib.Bubbles_together();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-210.7,155.3,1.102,1.102,0,85.1,-94.9,37.4,11.1);

	this.instance_10 = new lib.Bubbles_together();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-210.6,111.5,1.102,1.102,0,85.1,-94.9,36.4,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},128).wait(52));

	// Layer 4
	this.instance_11 = new lib.Bubbles_together();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-63.5,230.8,0.961,0.961,-90.8,0,0,35.8,10.8);

	this.instance_12 = new lib.Bubbles_together();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-33.7,235.9,0.961,0.961,41.2,0,0,35.8,10.8);

	this.instance_13 = new lib.Bubbles_together();
	this.instance_13.parent = this;
	this.instance_13.setTransform(-229.5,255.2,0.961,0.961,-92.7,0,0,35.7,11);

	this.instance_14 = new lib.Bubbles_together();
	this.instance_14.parent = this;
	this.instance_14.setTransform(-197.7,245.1,0.961,0.961,-92.7,0,0,35.7,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_14},{t:this.instance_13},{t:this.instance_12},{t:this.instance_11}]},1).to({state:[]},128).wait(52));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ElephantFrontLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":111});

	// Trunk Pt 3_bubbles
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(196.6,124.4,0.632,0.632,171.8,0,0,36.2,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(192.5,109.8,0.443,0.443,135.6,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},110).wait(21));

	// Elephant Trunk Part 6_bubbles
	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(225.3,131.3,0.632,0.632,171.8,0,0,36.2,11.1);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(210.3,111.8,0.443,0.443,135.6,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2}]},1).to({state:[]},110).wait(21));

	// Trunk Part 4_bubbles
	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(245.3,117.2,0.481,0.481,179.9,0,0,36,10.4);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(226,113.7,0.443,0.443,135.6,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5},{t:this.instance_4}]},1).to({state:[]},110).wait(21));

	// Trunk pt 2_bubbles
	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(250.2,93.5,0.437,0.437,109.9,0,0,35.9,11.1);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(241.4,109,0.403,0.403,65.6,0,0,35.9,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6}]},1).to({state:[]},110).wait(21));

	// Mud
	this.instance_8 = new lib.Bubbles_together();
	this.instance_8.parent = this;
	this.instance_8.setTransform(261.4,73.4,0.437,0.437,-145.1,0,0,35.8,11.2);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(1).to({_off:false},0).to({_off:true},110).wait(21));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.ElephantFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":240,"glowclean":241,"glowclean_loop":242,"final":243,"final_loop":244});

	// Layer 5
	this.instance = new lib.legGlow();
	this.instance.parent = this;
	this.instance.setTransform(139.6,60.7,1.466,1.407,0,0,0,-9.8,72);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(4).to({_off:false},0).to({_off:true},2).wait(290));

	// Actions
	this.instance_1 = new lib.ElephantFrontLeg0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-7,-5.9,0.5,0.5);

	this.instance_2 = new lib.left_over_bubbles_2();
	this.instance_2.parent = this;
	this.instance_2.setTransform(75.8,167.3,1,1,0,0,0,48.9,4.8);

	this.instance_3 = new lib.left_over_bubbles_sparse();
	this.instance_3.parent = this;
	this.instance_3.setTransform(89.4,178.7,1,1,0,0,0,47.6,10.1);

	this.instance_4 = new lib.left_over_bubbles_few();
	this.instance_4.parent = this;
	this.instance_4.setTransform(19,168.7,1,1,0,0,0,47.8,9.3);

	this.instance_5 = new lib.left_over_bubbles_sparse();
	this.instance_5.parent = this;
	this.instance_5.setTransform(30.1,187.3,1,1,0,0,0,47.6,10.1);

	this.instance_6 = new lib.left_over_bubbles_few();
	this.instance_6.parent = this;
	this.instance_6.setTransform(210.7,122.2,1,1,90,0,0,47.8,9.3);

	this.instance_7 = new lib.left_over_bubbles_sparse();
	this.instance_7.parent = this;
	this.instance_7.setTransform(224.9,159.5,1,1,0,0,0,47.6,10.1);

	this.instance_8 = new lib.left_over_bubbles_few();
	this.instance_8.parent = this;
	this.instance_8.setTransform(216,72.9,1,1,0,0,0,47.8,9.3);

	this.instance_9 = new lib.left_over_bubbles_2();
	this.instance_9.parent = this;
	this.instance_9.setTransform(186.7,87.2,1,1,0,0,0,48.9,4.8);

	this.instance_10 = new lib.left_over_bubbles();
	this.instance_10.parent = this;
	this.instance_10.setTransform(229.6,119.4,1,1,90,0,0,50.6,5.2);

	this.instance_11 = new lib.ElephantFrontLeg0002();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-7,-5.9,0.5,0.5);

	this.glow = new lib.blueglowlegs();
	this.glow.parent = this;
	this.glow.setTransform(139.6,60.7,1.466,1.407,0,0,0,-9.8,72);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3,p:{x:89.4,y:178.7}},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_11}]},2).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3,p:{x:89.4,y:178.7}},{t:this.instance_2}]},8).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3,p:{x:89.4,y:178.7}},{t:this.instance_2}]},226).to({state:[{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3,p:{x:89.4,y:178.7}},{t:this.instance_2},{t:this.glow}]},1).to({state:[{t:this.instance_11},{t:this.instance_3,p:{x:30.1,y:187.3}}]},2).to({state:[]},2).wait(51));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-7,-5.9,137.7,220);


(lib.water_drops_011 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(182.5,4.9,0.486,0.486,0,0,180,4.7,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(28.6,93.4,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(2.4,41.5,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(91.1,10.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.ElephantHead_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":90});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-44.4,63.4,1.084,1.084,-119.4,0,0,35.7,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-61.9,94.5,1.084,1.084,171.8,0,0,36.3,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-37.1,27.1,1.084,1.084,105.6,0,0,35.9,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},89).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Elephantear_001_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":45,"clean":51});

	// timeline functions:
	this.frame_0 = function() {
		/* 
		gameVars.earMud.push(this);
		if (gameVars.earMudClean == true) {this.alpha = 0;};*/
		/* stop();*/
	}
	this.frame_45 = function() {
		/* stop();*/
	}
	this.frame_51 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(45).call(this.frame_45).wait(6).call(this.frame_51).wait(6));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(55.6,92.4,1.084,1.084,-119.4,0,0,35.7,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(38.1,123.5,1.084,1.084,171.8,0,0,36.3,10.8);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(62.9,56.1,1.084,1.084,105.6,0,0,35.9,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},44).wait(12));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.Elephantear_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// mask (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_0 = new cjs.Graphics().p("AhaJdQg6higxipIgIhBQgFgdgLhsQgKhrgIgrQgGgkglh7Qglh6gghNQgihNByhMQArgiA/ggQB9g/BtAHQAvACA6AlQARAMAzAoQAYAMAeA8QAbA3AHAmQAFAegNBDQAEAHAAAxIAPBxIgDBYQAAAbgVACIgEAIIAaAvQAVArAABaQAAAGgPAMIgJAHQgJAKgMACQgSADgagOIgHgCIgIAVQgIAQAAACIAJA9QAAAJgKAZQgJAZAAAEQAAAJgPARQgVAugYAFQgHAXgQAlQggBJgoAHQgIAGgFABQgcAFgRgbIgBgBQgpBIgVAIIgGABQgUAAgagsg");
	var mask_graphics_1 = new cjs.Graphics().p("AhaJdQg6higxipIgIhBQgFgdgLhsQgKhrgIgrQgGgkglh7Qglh6gghNQgihNByhMQArgiA/ggQB9g/BtAHQAvACA6AlQARAMAzAoQAYAMAeA8QAbA3AHAmQAFAegNBDQAEAHAAAxIAPBxIgDBYQAAAbgVACIgEAIIAaAvQAVArAABaQAAAGgPAMIgJAHQgJAKgMACQgSADgagOIgHgCIgIAVQgIAQAAACIAJA9QAAAJgKAZQgJAZAAAEQAAAJgPARQgVAugYAFQgHAXgQAlQggBJgoAHQgIAGgFABQgcAFgRgbIgBgBQgpBIgVAIIgGABQgUAAgagsg");

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:mask_graphics_0,x:39.1,y:69.4}).wait(1).to({graphics:mask_graphics_1,x:39.1,y:69.4}).wait(1));

	// Mud
	this.instance = new lib.elephant_earMud_001();
	this.instance.parent = this;
	this.instance.setTransform(50.8,94.7,1.08,1.08,0,0,180,27.9,54.6);

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},1).wait(1));

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AAHFaQgdAKghgBQAigLAegOIACgsIglAhQgMAKgOAEQgGAmgKAlQgFAVgDARIADhsIgOgCIAOgFQAEhUAGhYQAJhxgphmIgbhFQBsDSgjDrQAggSAdgYQAHiagRiaIgXAVQgCACgDAAIAcgdIgDglIgkAVIgIABIArgeQgMhYgUhZQgBgDAFABQAVBXAMBYQA5gsAyg2IABAAQgrA9hAAsIAFAjQBchiAxh3QAAAAABAAQAAAAABAAQAAAAABAAQABAAABAAQgpB+hoBiQARCYgJCeQAqglAlgzQAog5Apg0QglBFhHBPQgZAegcAaIgEAvQAsgVAqgdQgBARgzAhQgSAJgRAHQgFAzgIA0QAAADgCACQAGg2AEg0gADKjJQAAAAABgBQAAAAAAAAQABAAAAAAQABAAABAAQAACehbCBQAAAAAAABQgBAAAAAAQgBABAAAAQgBAAgBAAQBUiBAHifgAipmcQAAAAABAAQAAgBAAAAQABAAABAAQAAAAABgBQgKAmgbAcIgDACQAOgeAWgkgAiglvQATgiAlgTQAlgSAmgNIAYACIACACQhYAEgwBEQgGAKgIAAQgDAAgEgCgAhTmXQAqgVAsgEQAngDAkAPIABADQhNgUhJAlIgvAVQAMgPAXgNg");
	this.shape.setTransform(38.4,56.4);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(2));

	// Layer 1
	this.instance_1 = new lib.EartPart2();
	this.instance_1.parent = this;
	this.instance_1.setTransform(58.6,45.5,1,1,0,0,0,14.5,23);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,3,3);

	this.instance_2 = new lib.ElephantEarPart();
	this.instance_2.parent = this;
	this.instance_2.setTransform(57.8,61.5,1,1,0,0,0,17.2,29.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,2,4);

	this.instance_3 = new lib.EarPart4();
	this.instance_3.parent = this;
	this.instance_3.setTransform(50.6,68.2,1,1,0,0,0,18.4,44.6);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,2,4);

	this.instance_4 = new lib.EarPart5();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.4,90.4,1,1,0,0,0,11,37.5);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",-1,2,4);

	this.instance_5 = new lib.EarPart6();
	this.instance_5.parent = this;
	this.instance_5.setTransform(28.8,93.3,1,1,0,0,0,13.7,37.5);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,2,2);

	this.instance_6 = new lib.ElephantEar();
	this.instance_6.parent = this;
	this.instance_6.setTransform(33.2,66.7,0.972,1.194,-9.8,0,0,21.9,43.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",0,0,2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},1).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8,-8,108,156);


(lib.elephant_trunkMud_006_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":56});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(12).call(this.frame_56).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(9.8,5.3,0.437,0.437,-145.1,0,0,35.8,11.2);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},43).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.elephant_trunkMud_005_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":56});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(12).call(this.frame_56).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(18.6,9.1,0.437,0.437,109.9,0,0,35.9,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.8,24.6,0.403,0.403,65.6,0,0,35.9,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.elephant_trunkMud_004_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":56});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(12).call(this.frame_56).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(28.4,8.4,0.481,0.481,179.9,0,0,36,10.3);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.1,4.8,0.443,0.443,135.6,0,0,35.9,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.elephant_trunkMud_003_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":56});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(12).call(this.frame_56).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(19.9,31.3,0.632,0.632,171.8,0,0,36.2,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(5,11.8,0.443,0.443,135.6,0,0,35.8,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.elephant_trunkMud_002_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"mud":0,"soap":44,"clean":56});

	// timeline functions:
	this.frame_0 = function() {
		/* stop();*/
	}
	this.frame_44 = function() {
		/* stop();*/
	}
	this.frame_56 = function() {
		/* stop();*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(44).call(this.frame_44).wait(12).call(this.frame_56).wait(12));

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(8.4,18.6,0.632,0.632,171.8,0,0,36.2,11.1);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(4.2,4.1,0.443,0.443,135.6,0,0,35.9,10.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_1},{t:this.instance}]},1).to({state:[]},43).wait(24));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.trunkmud5 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.Elephantear_001_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AIrG2IgVguIADgVQgSgbgNgeIgDADIgDgCIAFgDQgNgegKggIAGgyIARgWIAFADQABgHADgGIAJgDQAFgCAFABIAcAEIAJgOIAAgBQgEgFgFgBQgJgSgBgTIABgDQAdgUAiAFIABgDQACgFADgEQALgNAJgPIAPgKIAKgFIAJgGQAHgSAMgPQAHgIAJgFIARAAQANgOAMgKIgJgMIABAFQgPgdALgeIABgCIAHgBIABgCIABgCIASABQAFACAEAGQAEAEAFADQADgJACgKQABgJAEgGIAQAAQAFgMAHASIABAEIAAhBQgEgoASgQIAAAAIABgBIAGgDIAAABIAIgBIgBAFIAKAAIAAAAIACgBIAJgBIgCANIgBAKIAAgDQgEAuAKAjIgCgBIgBADQABAyAIAlIABAFIgFAGQAAAEABADIgHAYQgFABgCAGIgEAAQgEAGgBALIAAADIAHAMIAIABIgBACIgBAIIADAKQAFAHAEAIIACAFIAAACIAAABIAAAMIAAAMIgBAAIgBABIACABIAAAEIAAACIABABIgHAuIgGAHIgUAMIgXAAIAAACIgCgBIACACIgCANQgXAAgTAGIgCALQACADAEACIgHAtIgEADIgBgCIgEAOQgJAhgWAYIgEAAIgFAGIgIAFIABABIgBAAIgCACIgEABIgCAAQAAABAAAAQgBABAAAAQgBAAAAAAQgBAAgBAAIgDAJIgSAIQgQAoghAeIgFACIgEAIIgiAMIgeAAIgPgOgANEAXIAAgDIgCgNIACAQgAmfHDQgagEgPgKIgEgHIgBgBIgGgDQgBgHgGgFIgIgKIAAAAIAAgBIgDgDIAAgDQgEgIgIAAIAAAAIgEgBIgaANQgJAAgIgCQgLgDgFgFIgDgDQgHgBgGgDQgNgIgOgEIgGgIIgIgCIgDgIIgfg7IgBgBIgBgIIgCgDQgBAAAAAAQAAgBgBAAQAAAAAAAAQgBAAAAAAIgCgBIgDgBIgHgOQgIgDgJgHQgLgHgGgIIgOgDQgFgLgJgKIgBgBQgLgVgIgWIgEgRQgJglAQgbIAAgYIgCgFIgLABQAAgHgDgGIgDgDIgMgBQgcgCgfgFIgLgXIAAgBQgWgQgMgbQAIgkAOghIAEgGIAOgNIASgKQgChBgLg8IADgIQAMglACgyIgCgDIgEABQASgjgGguIAAADIgBgKIgEgNIAPABIAEABIAAAAIARAAIgCgFIAPABIAAgBIAJADIACABIAAAAQAfAQgHAoIAABBIACgEQATgbAQApIAEAjIAAACIANgFQA0gSAABJIgOA0QAKAEAGAGQATARgHAiIgBABIABABIAJAEIAGAGQASAGACASQABAGAFABIAAABIgDgBIAPAFIAFANQACACABACIADAHIAAABIAAABIgCAWIASgBQAsAAAAAbQgNAjgPAYQALgEAIgFQAHgFAMAAQAVAAAOAQQAMAPAGAdQAGAZgBAZQAPgGASAAQA5AAARA9QAEAOACAbIgBABQgJAfgQAhQgHASgGASQgGARgHANIgDADIgBAFIgDAEIgEAEIgCAFIgBAEIgCAAIgCADIgBAAIgBAEIgDAEIgCAEIgDADQgEALgLAIIgCACIgGgBgApzFpIgCgJIACgBIACAAIACAEIgBAJIgDgDgAIpCSIAAgDIADADIgDAAgAIkCHIACADIADAEIAAABg");
	this.shape.setTransform(82.6,46);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(31.4,59.3,0.668,0.668,43.7,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(27.5,67.5,0.532,0.532,64.7,0,0,35.9,10.8);

	this.instance_3 = new lib.earGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ABlGoIgBgCIgHgDQgGgMgJgLIgDgEIgEgBIgEgFQgLAHgJAJIgEADQgoAHgagjIgZghIgXhDQgDgIgEgFIgDgIQgFgCgDgEIgDgFIgEgBIAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAAAIAAAAIgIgBQgHgQgLgNIgBgBQgQgdgIgfQgIglAQgbIAAgYIgCgGIgEgEIgBgEIgBAAIgBgBIAAgBQgVATghgEIgFgBIgGgGIgFgDIgDgEIgDAAQgcgYAKgpQACgJgBgOIAMgqIAAgJIAMgOIAAgDQABhMgNhHIACgIQANglACgyIgCgDIgEAAQASgigHguIAAADIgBgKIgDgNIAPABQA4AKgKA2IAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAJAUQAGANAAAVIgCAVIASgBQArABAAAbQgNAjgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgDACIgEAFIgEABQgDAEgHAAIgLAAQgNgPgIgRgAhxDvIAAAAIABAAgAjnAuIAAgCIAEACg");
	this.shape_1.setTransform(30.8,45.6);

	this.glow = new lib.blueglowear();
	this.glow.parent = this;
	this.glow.setTransform(146,44.6,0.816,0.8,8.7,0,0,31.3,56.6);

	this.glow_1 = new lib.blueglowear();
	this.glow_1.parent = this;
	this.glow_1.setTransform(39.5,29.2,1.4,1,0,2,-178,31.2,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.9,0.8,177,90.5);


(lib.earmud4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.Elephantear_001_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AkjG/QgZgDgQgLIgEgGIgBgCIgGgDQgBgHgGgFIgHgJIAAgBIgBgBIgDgDIAAgCQgDgJgIABIgFgCIgZAOQgJgBgIgCQgOgDgFgHQgIgBgGgEQgMgHgPgEIgGgJQgJgBgCgEQAAAAAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAIgCgDQgKgFgHgJIgKggIABgBIgEgIIAAABIgDgHQgDgIgEgFIgDgHQgFgDgDgEIgDgFIgEgBIAAgBQgBAAAAAAQgBAAAAAAQgBgBAAAAQAAgBAAgBIAAAAIgIAAQgHgQgLgNIgBgCQgQgdgIgfQgIglAQgbIAAgXIgCgGIgLACQAAgHgEgHIgCgCIgMgBQgdgDgegEIgLgYIAAAAQgXgRgLgbQAIgjANghIAFgGIAOgOIARgKQgBhAgLg9IACgHQANglACgzIgCgCIgEAAQASgigHguIAAACIgBgKIgDgMIAPABIAEABIAAgBIARAAIgCgFIAPABIAAgBIAJAEIACAAIAAABQAfAPgHApIAABAIACgEQATgbAPApIAFAjIAAADIAMgGQA1gSAABJIgOA1QAlAOgKAwIABABQAaALAKAUQAGANAAAVIgDAVIASgBQAsABAAAaQgNAkgPAYQALgEAIgGQAHgFAMAAQApAAAMA9QAGAZgBAZQAPgHASAAQA5AAARA9QAEAOACAbIgBABQgJAfgPAiQgIARgGATQgFAQgHANIgEAEIgBAFIgDAEIgEADIgCAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgEALgKAIIgCACIgHgCgAJCFwIgFgKIABAAIAAgBQAAgOgEgMIAAAAIABgDIAAgDQgPgggEgiQgMgTgDgXIgBgBQAAgUADgTIgCgKIgBgBIAAgSQgBgdAGgcQABgGAFgGQACgEgBgEIAJgHQAWgZgCgkQAAgRAMgLIALgDIABgBQABgKAEgJIgKgOIACAFQgPgdALgfIAAgBIAHgCIABgBIACgCIASAAQAEADAFAGQADAEAGADQADgJABgLQACgJADgGIAPAAQAHgLAGARIACAEIAAhAQgEgpARgPIAAgBIACAAIAFgEIAAABIAIgBIgBAFIAKAAIAAABIACgBIAJgBIgCAMIgBAKIAAgCQgDAuAKAiIgCAAIgCACQACAzAHAlIABAFIgEAFQgBAEABAEIgHAYQgFABgCAFIgEAAQgEAHgBAKIAAAEIAHAMIAIAAIgBACIgBAJIADAJQAGAIADAHIACAFIAAACIAAABIAAAAIAAAMIAAANIgBAAIgBABIACAAIgBAFIACACIAAAAIgHAuIgGAHIgUAMIgXAAIgEAhQABADAFACIgHAtIgEADIgBgCIgFAOQgJAhgVAYIgFAAIgEAGIAIgFIgNANIgCgCIAHgGIgIAFIABABIgBAAIgCACIgEABIgCAAQAAABAAAAQgBABAAAAQgBAAAAAAQgBAAgBAAIgEAJIgHAYQgDADgCAFQgBADAAAFIABABIgBABIgBACQgIgFgEgLgAKxALIAAgCIgBgNIABAPg");
	this.shape.setTransform(70,44.9);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(31.4,59.3,0.668,0.668,43.7,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(27.5,67.5,0.532,0.532,64.7,0,0,35.9,10.8);

	this.instance_3 = new lib.earGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ABlGoIgBgCIgHgDQgGgMgJgLIgDgEIgEgBIgEgFQgLAHgJAJIgEADQgoAHgagjIgZghIgXhDQgDgIgEgFIgDgIQgFgCgDgEIgDgFIgEgBIAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAAAIAAAAIgIgBQgHgQgLgNIgBgBQgQgdgIgfQgIglAQgbIAAgYIgCgGIgEgEIgBgEIgBAAIgBgBIAAgBQgVATghgEIgFgBIgGgGIgFgDIgDgEIgDAAQgcgYAKgpQACgJgBgOIAMgqIAAgJIAMgOIAAgDQABhMgNhHIACgIQANglACgyIgCgDIgEAAQASgigHguIAAADIgBgKIgDgNIAPABQA4AKgKA2IAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAJAUQAGANAAAVIgCAVIASgBQArABAAAbQgNAjgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgDACIgEAFIgEABQgDAEgHAAIgLAAQgNgPgIgRgAhxDvIAAAAIABAAgAjnAuIAAgCIAEACg");
	this.shape_1.setTransform(30.8,45.6);

	this.glow = new lib.blueglowear();
	this.glow.parent = this;
	this.glow.setTransform(125.8,44,0.5,0.8,0,0,0,31.3,56.6);

	this.glow_1 = new lib.blueglowear();
	this.glow_1.parent = this;
	this.glow_1.setTransform(38.7,30.4,1.2,1,0,0,180,31.2,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-3.8,0,147.7,89.8);


(lib.earmud3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.Elephantear_001_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AjmG/QgagDgQgLIgDgGIgBgCIgGgDQgCgHgFgFIgIgJIAAgBIgBgBIgCgDIgBgCQgDgJgIABIgFgCIgZAOQgJgBgIgCQgOgDgFgHQgHgBgGgEQgNgHgOgEIgHgJQgIgBgCgEQgBAAAAgBQAAAAAAgBQAAAAAAgBQAAgBAAAAIgCgDQgKgFgGgJIgLggIABgBIgEgIIAAABIgCgHQgDgIgFgFIgCgHQgFgDgDgEIgDgFIgEgBIAAgBQgBAAgBAAQAAAAgBAAQAAgBAAAAQAAgBAAgBIgBAAIgIAAQgGgQgLgNIgBgCQgRgdgHgfQgJglARgbIAAgXIgCgGIgLACQgBgHgDgHIgCgCIgMgBQgdgDgegEIgLgYIgBAAQgWgRgMgbQAIgjAOghIAEgGIAOgOIASgKQgChAgLg9IADgHQAMglADgzIgDgCIgEAAQASgigGguIAAACIgBgKIgDgMIAOABIAEABIAAgBIARAAIgBgFIAOABIAAgBIAJAEIADAAIAAABQAeAPgHApIAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAKAUQAGANAAAVIgCAVIASgBQArABAAAaQgNAkgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgCACIgGgCgAJHDdQgHgLgFgMQgKgcAFgfQAEghAJgdIAEgFIAFgIQAQghAGgnQAEgcgHgaIAAgcQgBghgMgdQAGgRAIAUIACAEIAAhAQgEgpARgPIAAgBIACAAIAFgEIAAABIAIgBIgBAFIAKAAIAAABIACgBIAJgBIgCAMIgBAKIAAgCQgDAuAKAiIgCAAIgCACQACAzAHAlIABAEIgEAGIAAAIIgHAYQgFABgDAHQgCAIACAIQAHAJAEAHIACAFIAAAPIgBAdIAKAKIABABIAAABIACACIAEAHIAAABIgHAuIgGAHIgUAMIglgBIgJAJQgGAUADAOQABAEAGADIgHAtIgEADQgDgIgGgKgAKag2IgCgEIAEgMIAAABIgBAQIgBgBgAKYg6IAAAAg");
	this.shape.setTransform(68.1,45.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(31.4,59.3,0.668,0.668,43.7,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(27.5,67.5,0.532,0.532,64.7,0,0,35.9,10.8);

	this.instance_3 = new lib.earGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ABlGoIgBgCIgHgDQgGgMgJgLIgDgEIgEgBIgEgFQgLAHgJAJIgEADQgoAHgagjIgZghIgXhDQgDgIgEgFIgDgIQgFgCgDgEIgDgFIgEgBIAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAAAIAAAAIgIgBQgHgQgLgNIgBgBQgQgdgIgfQgIglAQgbIAAgYIgCgGIgEgEIgBgEIgBAAIgBgBIAAgBQgVATghgEIgFgBIgGgGIgFgDIgDgEIgDAAQgcgYAKgpQACgJgBgOIAMgqIAAgJIAMgOIAAgDQABhMgNhHIACgIQANglACgyIgCgDIgEAAQASgigHguIAAADIgBgKIgDgNIAPABQA4AKgKA2IAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAJAUQAGANAAAVIgCAVIASgBQArABAAAbQgNAjgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgDACIgEAFIgEABQgDAEgHAAIgLAAQgNgPgIgRgAhxDvIAAAAIABAAgAjnAuIAAgCIAEACg");
	this.shape_1.setTransform(30.8,45.6);

	this.glow = new lib.blueglowear();
	this.glow.parent = this;
	this.glow.setTransform(43.3,30.5,1.2,1,0,5.5,-174.5,31.2,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.3,0.6,135.6,89.8);


(lib.earmud2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.Elephantear_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-21.5,-45.5);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABwGmIgBgCIgGgDQgGgMgJgLIgEgEIAAAAQgBAFgDAEQgIAHgLAGIgjgCIAAABQglAFgZgiIgZghIgXhDQgDgIgEgFIgDgHQgFgDgDgEIgDgFIgEgBIAAgBQgBAAAAAAQgBAAAAgBQgBAAAAgBQAAAAAAgBIAAAAIgIAAQgHgQgLgNIgBgCQgQgdgIgfQgIglAQgbIAAgXIgCgGQgMADgPgCQgPAGgTgCIgFgBIgGgHIgFgCIgDgEIgDAAQgcgYAKgqQACgJgBgNIAMgrIAAgJIAMgOIAAgCQABhNgNhHIACgHQANglACgzIgCgCIgEAAQASgigHguIAAACIgBgKIgDgMIAPABIAEAAIAAAAIARAAIgCgFIAPABIgBgBIAKADIACABIAAABQAfAPgHApIAABAIACgEQATgbAPApIAFAjIAAADIAMgGQA1gSAABJIgOA1QAlAOgKAwIABABQAZALAKAUQAGANAAAVIgDAVIASgBQAsABAAAbQgNAjgPAYQALgEAIgGQAHgFAMAAQApAAAMA9QAGAZgBAZQAPgHASAAQA5AAARA9QAEAOACAbIgBABQgJAfgPAiQgIARgGATQgFAQgHANIgEAEIgBAFIgDAEIgEADIgCAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgEALgKAIIgEACIgDAFIgEABQgDAEgHAAIgLAAQgNgPgJgRgAh8D1IAAgBIABABgAjyA0IAAgDIAEADg");
	this.shape.setTransform(29.7,45.8);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(31.4,59.3,0.668,0.668,43.7,0,0,50.6,5.2);

	this.instance_2 = new lib.left_over_bubbles("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(27.5,67.5,0.532,0.532,64.7,0,0,35.9,10.8);

	this.instance_3 = new lib.earGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ABlGoIgBgCIgHgDQgGgMgJgLIgDgEIgEgBIgEgFQgLAHgJAJIgEADQgoAHgagjIgZghIgXhDQgDgIgEgFIgDgIQgFgCgDgEIgDgFIgEgBIAAgBQgBAAAAgBQgBAAAAAAQgBgBAAAAQAAgBAAAAIAAAAIgIgBQgHgQgLgNIgBgBQgQgdgIgfQgIglAQgbIAAgYIgCgGIgEgEIgBgEIgBAAIgBgBIAAgBQgVATghgEIgFgBIgGgGIgFgDIgDgEIgDAAQgcgYAKgpQACgJgBgOIAMgqIAAgJIAMgOIAAgDQABhMgNhHIACgIQANglACgyIgCgDIgEAAQASgigHguIAAADIgBgKIgDgNIAPABQA4AKgKA2IAABAIADgEQASgbAQApIAEAjIABADIAMgGQA0gSAABJIgOA1QAmAOgKAwIAAABQAaALAJAUQAGANAAAVIgCAVIASgBQArABAAAbQgNAjgPAYQAMgEAHgGQAHgFANAAQAoAAANA9QAFAZAAAZQAOgHASAAQA6AAARA9QAEAOACAbIgCABQgIAfgQAiQgIARgGATQgFAQgHANIgEAEIgBAFIgCAEIgEADIgDAFIgBAEIgBABIgCACIgBABIgBAEIgEADIgBAEIgEAEQgDALgLAIIgDACIgEAFIgEABQgDAEgHAAIgLAAQgNgPgIgRgAhxDvIAAAAIABAAgAjnAuIAAgCIAEACg");
	this.shape_1.setTransform(30.8,45.6);

	this.glow = new lib.blueglowear();
	this.glow.parent = this;
	this.glow.setTransform(39.7,30.5,1,1,0,0,180,31.2,56.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1}]},53).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(3.7,0.4,52,90.8);


(lib.trunkmud05 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// LABELS
	this.glow = new lib.blueglowtrunk();
	this.glow.parent = this;
	this.glow.setTransform(41.6,-10.9,1,1,45,0,0,37.8,45.1);
	this.glow._off = true;

	this.timeline.addTween(cjs.Tween.get(this.glow).wait(221).to({_off:false},0).to({_off:true},1).wait(82));

	// Layer 5
	this.instance = new lib.elephant_trunkMud_002_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACSGGIgRgGQgmgHgngNIgDgBIgJgBIgJABIgBACIgEgEIgDgBIgIgBIgFgEQgegWgbgbIgCACIgKgPIgDgCIAAgBIhAhbIABgBIgDgCIACADIgBABIgKgTIABgCIgGgLQgFgPgBgNIgHgVIgBgEIACgFIgDgSIgLgaIAAgGQgOgwAPgiQgHgqAQgfIgBgBIAFgLIADgJQAGgFAEgHIASgeIAzhYIARgWIABABIAQgcIACgDIgCgBIAJgLIAEgEIAIgOIAEgBQAXgeAcgdQALgEAHAIQADAEACAFQADAIgGAIIgBACQATAKgKAPIgBABQAFABADAEQAEAEABAEQAEAJgHAIIgBACQAUAKgLAPQgFAIgOALIABACIAIAAIgDACIgCABQADAEABADQABAFgDAHQgBAFgEAFQgDAGgFAFIAAAAIgCABIgIACIABAJQAAAGgEACIgCACIgKAJIgBAEIgBAHIABACIABAGQABAEgBADIABACIgCgCIAAACIABAFIgBAJQgEAMgLAIIgBABIgCACIgGACIgBAAIgGAEIAGAFIAHAEIABAAIABACIAAAIIgBACIgEADIgEAEIgBAEIgGAFIgBABIgBABIgGADIAEAJQABADAAADQgBAKgIAGQgHAEgVAJIgCACIgEABQAAABAAAAQAAABAAAAQAAAAABABQAAAAAAABIABABQASAMgBAGQAAAFgOAMIgBABQgBAKgEAJQgCAHgDADIgBACQgDAFgEACIAAAAIgKABIgCAKQAbAMAHAFQAIAGAAAJIAAADIgBADIgEAJIAUAPQADACAAAFIAAAKQgBAEgDADIAHAGQAEADgBAEIAAAEIgCAVIAJACQACABADADQAHAGgBAKIgCALQADgBACABIACABQAEAEADASIAAABQAHAGAGAJQAEAFABAFQADAHAAAFIgDAGIgCACIABAAIABAAQATgBAEADQAGAEgEAVIAAACIAEAEQAZgNAIgCQAKgCAHAGIAEAFIAEAJIATgEIATATIgBADIAAACIABAIIAJANIgHAHIgGAAIgFAFIgLAEg");
	this.shape.setTransform(20,-2.7);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.3,9.2,0.5,0.5,-82.5,0,0,50.5,5.2);

	this.instance_2 = new lib.elephant_trunkGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(42.1,4.4,1,1,48.8,0,0,37.8,45);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ADGGSIgHgEIgTgTIgIAAIgJgFIgPABIgdgMQgNgGgLACIgGgDQgPADgRgHQgSgJgQgJIgHgEQgRgJgLgOIgKgDIgFgFQgrgmgggyIg/hgIABgBIgDgCIACADIAAAAIgKgSIABgCIgGgMQgEgPgBgNIgFgVIgBgEIACgFIgEgaQACgEAAgFQgBgfAGgfIgCgMIABgBQAMgeAMgbQAGgFAFgHIASgdIA3hWIARgWQAYAoAjAZIAGADQgCAJgEAIQgHARgLADQAHAFABAGIAAAKQgBAFgDABIgVAOIADAJQABACAAAEQgBAJgJAGQgGAEgWAIIgCACIgEABIABAEIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAJQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbAMAGAFQAIAGAAAKIgBAGIgFAIIAUAQQADACAAAFIgBAKQgBAEgDACIAHAHQAEAEgCADIgCAZIAJADQADABACACQAHAHgBAKQgBAIgKAbQACACADABIACAAQAUgGAFAFQADAEABASIAAABQAGAHAFAKQADAGAAAEQACAHgBAFIgFAHIABABIABAAQATABADADQAFAFgFAVIAAACQAAACACACQAbgKAJAAQAKgBAGAGQADADABADIADAJIAYgDQAEgBAEAEIAGAHQADAFgCAJQAKgFAQAIQAJAFAIAHIABAAQASAAAEAEQAFAFgFAUIgBACIADAFQAOAagFAQgAAbkdIgBgBQgggLgfgQIgBgBIgCAAQgDgCgDAAIgCgBIAKgLQAggmAlglQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKQAGAHABAGQABAFgDAHIgFAKIgJAKg");
	this.shape_1.setTransform(20.6,14.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1}]},53).to({state:[]},163).to({state:[]},1).wait(81));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(2.4,-41.7,35.1,78.1);


(lib.trunkmud4 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.elephant_trunkMud_002_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACKFpIgRgGQglgHgogNIgDgBIgJgBIgJABIgBACIgEgEIgDgBIgHgBIgGgEQgegWgbgbIgCACIgKgPIgDgCIABgBIhBhbIABgBIgDgCIACADIAAABIgKgTIAAgCIgGgLQgEgPgCgNIgGgVIgCgEIADgFIgGgbQACgEAAgFQgBgfAEgeIgCgMIAAgCIAXg5QAGgFAEgHIARgeIA0hYIARgWIABABIASgfIgCgBIAJgLIAEgEIAIgOIADgBQAYgeAbgdQALgEAIAIQALANgKAMIgBACQAUAKgLAPQgFAIgOALIABACIAIAAIgDACIgCABQADAEABADQABAFgDAHQgBAFgEAFQgDAGgFAFIAAAAIgCABIgIACIABAJQAAAGgDACIgCACIgLAJIgBAEIgBAHIABACIABAGQABAEgBADIACACIgDgCIAAACIABAFIgBAJQgEAMgLAIIAAABIgDACIgFACIgBAAIgFAEIAFAFIAGAEIABAAIABACIAAAIIgBACIgEADIgDAEIgBAEIgGAFIgBABIgCABIgFADIADAJQACADgBADQgBAKgIAGQgHAEgVAJIgCACIgDABQgBABAAAAQAAABAAAAQAAABABAAQAAAAAAABIACABQARAMAAAHQgBAFgOAMIgBABQAAAJgFAJQgCAHgCADQgFAHgEACIgJABIgCAKQAaAMAHAFQAIAGAAAJIAAADIgBADIgDAJIAUAPQACACAAAFIAAAKQgBAEgCADIAHAGQAEADgCAEIABAEIgCAVIAJACQADABACADQAGAGgBAKIgBALQACgBACABIADABQADAEADASIAAABQAHAGAHAJQADAFABAFQADAHAAAFIgDAGIgCACIABAAIABAAQATgBAEADQAGAEgEAVIAAACIAEAEQAZgNAIgCQALgCAGAGIAFAFIADAJIATgEIATATIgBADIAAACIABAIIAJANIgHAHIgGAAIgFAFIgLAEg");
	this.shape.setTransform(19.6,0.5);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.3,9.2,0.5,0.5,-82.5,0,0,50.5,5.2);

	this.instance_2 = new lib.elephant_trunkGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(42.1,4.4,1,1,48.8,0,0,37.8,45);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ADGGSIgHgEIgTgTIgIAAIgJgFIgPABIgdgMQgNgGgLACIgGgDQgPADgRgHQgSgJgQgJIgHgEQgRgJgLgOIgKgDIgFgFQgrgmgggyIg/hgIABgBIgDgCIACADIAAAAIgKgSIABgCIgGgMQgEgPgBgNIgFgVIgBgEIACgFIgEgaQACgEAAgFQgBgfAGgfIgCgMIABgBQAMgeAMgbQAGgFAFgHIASgdIA3hWIARgWQAYAoAjAZIAGADQgCAJgEAIQgHARgLADQAHAFABAGIAAAKQgBAFgDABIgVAOIADAJQABACAAAEQgBAJgJAGQgGAEgWAIIgCACIgEABIABAEIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAJQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbAMAGAFQAIAGAAAKIgBAGIgFAIIAUAQQADACAAAFIgBAKQgBAEgDACIAHAHQAEAEgCADIgCAZIAJADQADABACACQAHAHgBAKQgBAIgKAbQACACADABIACAAQAUgGAFAFQADAEABASIAAABQAGAHAFAKQADAGAAAEQACAHgBAFIgFAHIABABIABAAQATABADADQAFAFgFAVIAAACQAAACACACQAbgKAJAAQAKgBAGAGQADADABADIADAJIAYgDQAEgBAEAEIAGAHQADAFgCAJQAKgFAQAIQAJAFAIAHIABAAQASAAAEAEQAFAFgFAUIgBACIADAFQAOAagFAQgAAbkdIgBgBQgggLgfgQIgBgBIgCAAQgDgCgDAAIgCgBIAKgLQAggmAlglQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKQAGAHABAGQABAFgDAHIgFAKIgJAKg");
	this.shape_1.setTransform(20.6,14.7);

	this.glow = new lib.blueglowtrunk();
	this.glow.parent = this;
	this.glow.setTransform(41.6,-3.5,1,1,45,0,0,37.8,45.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1}]},53).to({state:[{t:this.instance_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(2.8,-35.6,33.5,72.3);


(lib.trunkmud3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.elephant_trunkMud_002_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AB7FrIgBgBIgMgDIgIADIgFgBIgEgDIgFAAIgZgBIABABIgDgBIACAAIAAgBIgGgBIgGgDIgIgDQgSgIgMgNIgKgCIgEgEQgegXgbgcIgCACIgJgPIgDgDIAAgBIg9hdIABgBIgDgCIACADIAAABIgKgTIABgCIgGgMQgEgPgBgMIgFgWIgBgEIACgFIgEgbQACgEAAgFQgBgfAGgeIgCgMIABgBIAYg5QAGgFAFgHIASgdIA3hWIARgVIABABIATgfIgCgBIAKgLIACgDIAJgOIAEgBQAZgdAdgcQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKIABACIAIABIgDACIgCAAQADAEAAAEQABAFgDAHIgFAKIgJAKIAAAAIgCABQgDACgEAAIAAAJQAAAGgEABIgCACIgLAJIgBAEIgBAHIABACIABAGIgBAHIACACIgCgCIgBACIABAFIgBAJQgFAMgLAIIAAAAIgCACIgHACIgBAAIgGAEIAGAFIAHAEIAAAAIABADIAAAIIAAABIgFADIgEAEIgBAEIgHAEIgBACIgBAAIgFAEIADAJQABACAAAEQgBAJgJAGIgcAMIgCACIgEABQAAABAAAAQAAAAAAABQAAAAAAABQAAAAABABIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAIQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbANAGAFQAIAGAAAKIAAADIgBADIgFAIIAUAQQADACAAAFIgBAKQgBAEgDADIAHAGQAEAEgCADIAAAEIgCAVIAJADQADABACACQAGAHgBAKIgCALQADgBACABIACABQADAEADASIAAABQAGAHAGAJQAEAFABAFQACAHAAAFIgDAGIgCACIABAAIABAAQATAAAEACQAFAFgEAUIAAACQABADACACQAagMAIgCQAKgBAHAGIAEAFIAEAJIASgDIATATIgBADIAAACIABAIIAIANIgHAHIgGAAIgFAEIgSAGgAAni2IAAgBIABACIgBgBg");
	this.shape.setTransform(17.8,-1.7);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.3,9.2,0.5,0.5,-82.5,0,0,50.5,5.2);

	this.instance_2 = new lib.elephant_trunkGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(42.1,4.4,1,1,48.8,0,0,37.8,45);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ADGGSIgHgEIgTgTIgIAAIgJgFIgPABIgdgMQgNgGgLACIgGgDQgPADgRgHQgSgJgQgJIgHgEQgRgJgLgOIgKgDIgFgFQgrgmgggyIg/hgIABgBIgDgCIACADIAAAAIgKgSIABgCIgGgMQgEgPgBgNIgFgVIgBgEIACgFIgEgaQACgEAAgFQgBgfAGgfIgCgMIABgBQAMgeAMgbQAGgFAFgHIASgdIA3hWIARgWQAYAoAjAZIAGADQgCAJgEAIQgHARgLADQAHAFABAGIAAAKQgBAFgDABIgVAOIADAJQABACAAAEQgBAJgJAGQgGAEgWAIIgCACIgEABIABAEIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAJQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbAMAGAFQAIAGAAAKIgBAGIgFAIIAUAQQADACAAAFIgBAKQgBAEgDACIAHAHQAEAEgCADIgCAZIAJADQADABACACQAHAHgBAKQgBAIgKAbQACACADABIACAAQAUgGAFAFQADAEABASIAAABQAGAHAFAKQADAGAAAEQACAHgBAFIgFAHIABABIABAAQATABADADQAFAFgFAVIAAACQAAACACACQAbgKAJAAQAKgBAGAGQADADABADIADAJIAYgDQAEgBAEAEIAGAHQADAFgCAJQAKgFAQAIQAJAFAIAHIABAAQASAAAEAEQAFAFgFAUIgBACIADAFQAOAagFAQgAAbkdIgBgBQgggLgfgQIgBgBIgCAAQgDgCgDAAIgCgBIAKgLQAggmAlglQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKQAGAHABAGQABAFgDAHIgFAKIgJAKg");
	this.shape_1.setTransform(20.6,14.7);

	this.glow = new lib.blueglowtrunk();
	this.glow.parent = this;
	this.glow.setTransform(44.5,-7.2,1,1,45,0,0,37.8,45.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1}]},53).to({state:[{t:this.instance_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.6,-38,32.5,72.6);


(lib.trunkmud2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_loop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":220,"glowclean":221,"glowclean_loop":222,"final":223,"final_loop":224});

	// Layer 5
	this.instance = new lib.elephant_trunkMud_002_bubbles();
	this.instance.parent = this;
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).to({_off:true},214).wait(84));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ACMFuIgHgCQgNgFgLACIgGgCQgPAEgRgGQgTgHgQgIIgIgDQgSgJgLgNIgLgCIgFgEQgegXgagcIgCACIgKgPIgDgDIABAAIg9hdIABgCIgDgBIACADIgBAAIgJgTIAAgCIgFgLQgEgPgBgNIgGgVIgBgEIACgGIgEgbQACgEAAgFQAAgeAFgeIgBgMIAAgCIAZg4QAGgFAEgHIATgdIA2hXIASgVIAAABIAUgeIgCgBIAJgLIADgEIAKgNIAEgCQAYgcAcgcQAMgEAGAIQALAOgKALIgBACQATALgKAOQgGAIgPALIACACIAHAAIgDACIgCABQADAEABADQABAFgDAHIgFAKIgJALIgBgBIgBACQgEABgEAAIAAAJQAAAGgDACIgCACIgLAIIgBAFIgCAHIABABIACAHQgBAIgGAGIACABIAAAAIgTgIIgFABIgUgJIgGAAIgLAEQALAdAbAXIAGAFIABAAIABACIgBAKQAAAFgDACIgNAIIgBABIgBABIgGADIAEAJQABADgBADQgBAKgIAGIgdAMIgBABIgEACQAAAAAAABQAAAAAAABQAAAAAAAAQAAABAAAAIACACQARAMgBAHQgBAFgOAMIgBABQgBAJgEAKQgDAFgDAEQgEAGgFACQgEABgFAAIgCAKQAaAMAHAFQAHAHAAAJIAAADIgBADIgEAJIATAPQADACAAAGIAAAKQgBADgDADIAGAGQAEAEgBAEIAAADIgDAVIAJADQADABADADQAGAGgBAKIgCALIAFABIACABQAEADACATIAAABQAGAGAGAJQADAGABAEQADAHgBAFIgDAHIgBABIABABIABAAQASgBAEADQAGAEgEAVIAAACQAAACADACQAZgMAJgBQAKgCAHAGIAEAFIADAJIATgDIASATIAAAEIgBACIABAHIALARIAEAGIACAAIAAAAIAEAEQAJAMAKAKIgPACIgXgHg");
	this.shape.setTransform(18.5,11.6);

	this.instance_1 = new lib.left_over_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(9.3,9.2,0.5,0.5,-82.5,0,0,50.5,5.2);

	this.instance_2 = new lib.elephant_trunkGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(42.1,4.4,1,1,48.8,0,0,37.8,45);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("ADGGSIgHgEIgTgTIgIAAIgJgFIgPABIgdgMQgNgGgLACIgGgDQgPADgRgHQgSgJgQgJIgHgEQgRgJgLgOIgKgDIgFgFQgrgmgggyIg/hgIABgBIgDgCIACADIAAAAIgKgSIABgCIgGgMQgEgPgBgNIgFgVIgBgEIACgFIgEgaQACgEAAgFQgBgfAGgfIgCgMIABgBQAMgeAMgbQAGgFAFgHIASgdIA3hWIARgWQAYAoAjAZIAGADQgCAJgEAIQgHARgLADQAHAFABAGIAAAKQgBAFgDABIgVAOIADAJQABACAAAEQgBAJgJAGQgGAEgWAIIgCACIgEABIABAEIABABQARANgBAHQAAAEgOAMIgBABQgCAKgEAJQgCAHgDADQgFAGgEADQgEABgGgBIgCAKQAbAMAGAFQAIAGAAAKIgBAGIgFAIIAUAQQADACAAAFIgBAKQgBAEgDACIAHAHQAEAEgCADIgCAZIAJADQADABACACQAHAHgBAKQgBAIgKAbQACACADABIACAAQAUgGAFAFQADAEABASIAAABQAGAHAFAKQADAGAAAEQACAHgBAFIgFAHIABABIABAAQATABADADQAFAFgFAVIAAACQAAACACACQAbgKAJAAQAKgBAGAGQADADABADIADAJIAYgDQAEgBAEAEIAGAHQADAFgCAJQAKgFAQAIQAJAFAIAHIABAAQASAAAEAEQAFAFgFAUIgBACIADAFQAOAagFAQgAAbkdIgBgBQgggLgfgQIgBgBIgCAAQgDgCgDAAIgCgBIAKgLQAggmAlglQALgDAHAIQAKANgJAMIgBACQATALgLAOQgGAIgOAKQAGAHABAGQABAFgDAHIgFAKIgJAKg");
	this.shape_1.setTransform(20.6,14.7);

	this.glow = new lib.blueglowtrunk();
	this.glow.parent = this;
	this.glow.setTransform(40.7,5.9,1,1,45,0,0,37.8,45.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.shape_1},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1}]},53).to({state:[{t:this.instance_1},{t:this.glow}]},162).to({state:[]},2).to({state:[]},1).wait(80));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0.8,-25.7,35.6,74.7);


(lib.ElephantHead_005 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 7
	this.trunkmud = new lib.trunkmud05();
	this.trunkmud.parent = this;
	this.trunkmud.setTransform(70.4,194.8,1,1,0,51,-129,8.5,17.6);

	this.earmud = new lib.trunkmud5();
	this.earmud.parent = this;
	this.earmud.setTransform(-36.1,40.1,1,1,-8.6);

	this.instance = new lib.ElephantHead_0050004();
	this.instance.parent = this;
	this.instance.setTransform(-39.7,2.1,0.5,0.5);

	this.instance_1 = new lib.ElephantHead_0050001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-39.7,2.1,0.5,0.5);

	this.instance_2 = new lib.ElephantHead_0050002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-39.7,2.1,0.5,0.5);

	this.instance_3 = new lib.ElephantHead_0050003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-39.7,2.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.earmud},{t:this.trunkmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-43.5,-2.4,199.2,213.8);


(lib.ElephantHead_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 5
	this.trunkmud = new lib.trunkmud4();
	this.trunkmud.parent = this;
	this.trunkmud.setTransform(76.3,194.2,1,1,0,51,-129,8.5,17.6);

	this.earmud = new lib.earmud4();
	this.earmud.parent = this;
	this.earmud.setTransform(5.5,89.4,1,1,-8.6,0,0,27.8,54.7);

	this.instance = new lib.ElephantHead_0040004();
	this.instance.parent = this;
	this.instance.setTransform(-32.4,2.3,0.5,0.5);

	this.instance_1 = new lib.ElephantHead_0040001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-32.4,2.3,0.5,0.5);

	this.instance_2 = new lib.ElephantHead_0040002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-32.4,2.3,0.5,0.5);

	this.instance_3 = new lib.ElephantHead_0040003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-32.4,2.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.earmud},{t:this.trunkmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},200).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-36.3,-1.8,183.3,212.4);


(lib.ElephantHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 5
	this.trunkmud = new lib.trunkmud3();
	this.trunkmud.parent = this;
	this.trunkmud.setTransform(76.3,194.2,1,1,0,51,-129,8.5,17.6);

	this.earmud = new lib.earmud3();
	this.earmud.parent = this;
	this.earmud.setTransform(5.5,89.4,1,1,-8.6,0,0,27.8,54.7);

	this.instance = new lib.ElephantHead_0030004();
	this.instance.parent = this;
	this.instance.setTransform(-27.9,4.3,0.5,0.5);

	this.instance_1 = new lib.ElephantHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-27.9,4.3,0.5,0.5);

	this.instance_2 = new lib.ElephantHead_0030002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-27.9,4.3,0.5,0.5);

	this.instance_3 = new lib.ElephantHead_0030003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-27.9,4.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.earmud},{t:this.trunkmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).wait(200));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-32,0.4,175.2,209.9);


(lib.ElephantHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 5
	this.trunkmud = new lib.trunkmud2();
	this.trunkmud.parent = this;
	this.trunkmud.setTransform(86.3,186.9,1,1,0,51,-129,8.5,17.6);

	this.earmud = new lib.earmud2();
	this.earmud.parent = this;
	this.earmud.setTransform(10,87.2,1,1,0,0,0,27.9,54.6);

	this.instance = new lib.ElephantHead_0020004();
	this.instance.parent = this;
	this.instance.setTransform(-18,1,0.5,0.5);

	this.instance_1 = new lib.ElephantHead_0020001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-18,1,0.5,0.5);

	this.instance_2 = new lib.ElephantHead_0020002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-18,1,0.5,0.5);

	this.instance_3 = new lib.ElephantHead_0020003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-18,1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.earmud},{t:this.trunkmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},199).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-21.5,-3.8,151.2,216.5);


(lib.ElephantHead_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209});

	// Layer 7
	this.instance = new lib.Elephantear_001_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(-31,-31.4);

	this.instance_1 = new lib.elephant_trunkMud_002_bubbles();
	this.instance_1.parent = this;
	this.instance_1.setTransform(102.7,112.6,1,1,0,0,0,8.6,17.6);

	this.instance_2 = new lib.elephant_trunkMud_003_bubbles();
	this.instance_2.parent = this;
	this.instance_2.setTransform(103.4,142.3,1,1,0,0,0,17.3,21.2);

	this.instance_3 = new lib.elephant_trunkMud_004_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(73.7,188.9,1,1,0,0,0,20.9,9.2);

	this.instance_4 = new lib.elephant_trunkMud_005_bubbles();
	this.instance_4.parent = this;
	this.instance_4.setTransform(98.4,162.7,0.998,0.998,49.9,0,0,12.5,16.2);

	this.instance_5 = new lib.elephant_trunkMud_006_bubbles();
	this.instance_5.parent = this;
	this.instance_5.setTransform(85.5,182.4,1,1,0,0,0,12.5,7.3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},6).wait(204));

	// Layer 5
	this.trunkmud = new lib.elephant_trunkMud_002();
	this.trunkmud.parent = this;
	this.trunkmud.setTransform(89.7,182.8,1,1,0,51,-129,8.5,17.6);

	this.earmud = new lib.elephant_earMud_001();
	this.earmud.parent = this;
	this.earmud.setTransform(17.5,87.2,1,1,0,0,0,27.9,54.6);

	this.instance_6 = new lib.ElephantHead_0010004();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-8,0.1,0.5,0.5);

	this.instance_7 = new lib.earGlow();
	this.instance_7.parent = this;
	this.instance_7.setTransform(29,64.5,1.096,1.096,0,0,180,31.4,56.6);

	this.instance_8 = new lib.elephant_trunkGlow();
	this.instance_8.parent = this;
	this.instance_8.setTransform(75.5,148,1,1,0,0,180,37.8,45.1);

	this.instance_9 = new lib.ElephantHead_0010001();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-8,0.1,0.5,0.5);

	this.instance_10 = new lib.ElephantHead_0010002();
	this.instance_10.parent = this;
	this.instance_10.setTransform(-8,0.1,0.5,0.5);

	this.instance_11 = new lib.ElephantHead_0010003();
	this.instance_11.parent = this;
	this.instance_11.setTransform(-8,0.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6},{t:this.earmud},{t:this.trunkmud}]}).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_9},{t:this.instance_8},{t:this.instance_7}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_10}]},2).to({state:[{t:this.instance_11}]},2).wait(200));

	// Layer 3
	this.instance_12 = new lib.Elephant_blink();
	this.instance_12.parent = this;
	this.instance_12.setTransform(83.3,77.5,1,1,0,0,0,6.9,6.7);

	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true},2).wait(208));

	// Eye
	this.instance_13 = new lib.ElephantEye_001();
	this.instance_13.parent = this;
	this.instance_13.setTransform(84,77.6,1,1,0,0,0,5,5.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_13).to({_off:true},2).wait(208));

	// Elephant ear_001
	this.instance_14 = new lib.Elephantear_001("synched",0);
	this.instance_14.parent = this;
	this.instance_14.setTransform(24.9,63,0.922,0.922,0,0,180,44.1,68.3);

	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true},2).wait(208));

	// Elephant Face_001
	this.instance_15 = new lib.ElephantFace_001();
	this.instance_15.parent = this;
	this.instance_15.setTransform(72.9,89.3,1,1,0,0,0,47.2,70.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_15).to({_off:true},2).wait(208));

	// Elephant Trunk
	this.instance_16 = new lib.ElephantTrunk("synched",0);
	this.instance_16.parent = this;
	this.instance_16.setTransform(100,113.4,0.922,0.922,0,0,180,15.8,32.6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({_off:true},2).wait(208));

	// Layer 2
	this.instance_17 = new lib.ElephantMouth_001();
	this.instance_17.parent = this;
	this.instance_17.setTransform(71.4,127.6,1,1,0,0,0,19.4,12.2);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({_off:true},2).wait(208));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10.9,-3.8,139.5,216.7);


(lib.Elephant = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:38,rest_stop:176,"clean":178,clean_stop:186,wet:188,wet_stop:198,excited:200,excited_stop:310,animalSound:312});

	// timeline functions:
	this.frame_36 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_176 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_186 = function() {
		/* stop();
		
		*/
	}
	this.frame_198 = function() {
		/* stop();*/
	}
	this.frame_307 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_359 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(36).call(this.frame_36).wait(140).call(this.frame_176).wait(10).call(this.frame_186).wait(12).call(this.frame_198).wait(109).call(this.frame_307).wait(52).call(this.frame_359).wait(1));

	// hind leg bubbles
	this.legs_bubbles = new lib.ElephantHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(-299.2,173.3,0.7,0.7,0,0,180,61.6,82.2);
	this.legs_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(38).to({_off:true},150).wait(172));

	// Elephant Torso
	this.back_bubbles = new lib.ElephantTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(-271.6,165.8,0.7,0.7,0,0,180,210.2,102.3);
	this.back_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(38).to({_off:true},150).wait(172));

	// ear
	this.ear_bubbles = new lib.ElephantHead_001_bubbles();
	this.ear_bubbles.parent = this;
	this.ear_bubbles.setTransform(-154.9,175.7,1,1,0,0,0,29.1,103.2);

	this.ear_bubbles_1 = new lib.sparkle();
	this.ear_bubbles_1.parent = this;
	this.ear_bubbles_1.setTransform(-312.9,236.4,0.75,0.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.ear_bubbles}]}).to({state:[{t:this.ear_bubbles}]},38).to({state:[]},150).to({state:[{t:this.ear_bubbles_1}]},95).to({state:[]},29).wait(48));

	// trunk
	this.trunk_bubbles = new lib.ElephantFrontLeg_bubbles();
	this.trunk_bubbles.parent = this;
	this.trunk_bubbles.setTransform(-198.7,183.8,0.7,0.7,0,0,180,69.5,29.9);
	this.trunk_bubbles.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.trunk_bubbles_1 = new lib.sparkle();
	this.trunk_bubbles_1.parent = this;
	this.trunk_bubbles_1.setTransform(-305.2,139.7,0.75,0.75);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.trunk_bubbles}]}).to({state:[{t:this.trunk_bubbles}]},38).to({state:[]},150).to({state:[{t:this.trunk_bubbles_1}]},117).to({state:[]},7).wait(48));

	// sparkle
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(-175.6,164.2,0.75,0.75,0,0,180);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(296).to({_off:false},0).to({_off:true},16).wait(48));

	// sparkle
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(243.7,215.9,0.75,0.75,0,0,180);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(289).to({_off:false},0).to({_off:true},23).wait(48));

	// sparkle
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(439.7,-130.3,0.75,0.75,0,0,180);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(266).to({_off:false},0).to({_off:true},46).wait(48));

	// sparkle
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-308.2,117.2,0.75,0.75,0,0,180);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(274).to({_off:false},0).to({_off:true},38).wait(48));

	// WET DROPS
	this.instance_4 = new lib.water_drops_011();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-179,146.7,1,1,0,0,180,92.4,49.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(188).to({_off:false},0).to({_off:true},12).wait(160));

	// Elephant Head_001
	this.instance_5 = new lib.ElephantHead_011("synched",0,false);
	this.instance_5.parent = this;
	this.instance_5.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(204).to({_off:false},0).wait(2).to({skewX:7.5,skewY:187.5,x:-259.9,y:167.7,startPosition:2},0).wait(2).to({scaleX:1,scaleY:1,skewX:15.1,skewY:195.1,x:-265.4,y:169.3,startPosition:4},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,x:-270.7,y:170.9,startPosition:6},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.6,skewY:202.6,startPosition:8},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,startPosition:10},0).wait(2).to({scaleX:1,scaleY:1,skewX:17.6,skewY:197.6,x:-266.5,y:170.2,startPosition:12},0).wait(2).to({regX:28.6,skewX:12.8,skewY:192.8,x:-261.8,y:169.6,startPosition:14},0).wait(2).to({regX:29.2,regY:102.1,scaleX:1,scaleY:1,skewX:7.8,skewY:187.8,x:-258,y:167.6,startPosition:16},0).wait(2).to({regX:28.7,regY:102.4,skewX:2.8,skewY:182.8,x:-253.5,y:167.1,startPosition:18},0).wait(2).to({regX:29.1,regY:103.2,skewX:0,skewY:180,x:-254.5,y:166,startPosition:20},0).wait(2).to({startPosition:22},0).wait(2).to({startPosition:24},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({skewX:7.5,skewY:187.5,x:-259.9,y:167.7,startPosition:2},0).wait(2).to({scaleX:1,scaleY:1,skewX:15.1,skewY:195.1,x:-265.4,y:169.3,startPosition:4},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,x:-270.7,y:170.9,startPosition:6},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.6,skewY:202.6,startPosition:8},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,startPosition:10},0).wait(2).to({scaleX:1,scaleY:1,skewX:17.6,skewY:197.6,x:-266.5,y:170.2,startPosition:12},0).wait(2).to({regX:28.6,skewX:12.8,skewY:192.8,x:-261.8,y:169.6,startPosition:14},0).wait(1).to({regX:29.2,regY:101.9,scaleX:1,scaleY:1,skewX:7.8,skewY:187.8,x:-258,y:167.4,startPosition:16},0).wait(1).to({regX:28.5,regY:102.2,skewX:2.8,skewY:182.8,x:-253.3,y:167,startPosition:18},0).wait(1).to({regX:29.1,regY:103.2,skewX:0,skewY:180,x:-254.5,y:166,startPosition:20},0).wait(1).to({startPosition:22},0).to({_off:true},54).wait(3).to({_off:false,startPosition:0},0).wait(2).to({skewX:7.5,skewY:187.5,x:-259.9,y:167.7,startPosition:2},0).wait(2).to({scaleX:1,scaleY:1,skewX:15.1,skewY:195.1,x:-265.4,y:169.3,startPosition:4},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,x:-270.7,y:170.9,startPosition:6},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.6,skewY:202.6,startPosition:8},0).wait(2).to({scaleX:1,scaleY:1,skewX:22.7,skewY:202.7,startPosition:10},0).wait(2).to({scaleX:1,scaleY:1,skewX:17.6,skewY:197.6,x:-266.5,y:170.2,startPosition:12},0).wait(2).to({regX:28.6,skewX:12.8,skewY:192.8,x:-261.8,y:169.6,startPosition:14},0).wait(2).to({regX:29.2,regY:102,scaleX:1,scaleY:1,skewX:7.8,skewY:187.8,x:-258,y:167.5,startPosition:16},0).wait(2).to({regX:28.7,regY:102.3,skewX:2.8,skewY:182.8,x:-253.5,y:167,startPosition:18},0).wait(2).to({regX:29.1,regY:103.2,skewX:0,skewY:180,x:-254.5,y:166,startPosition:20},0).wait(2).to({startPosition:22},0).wait(2).to({startPosition:24},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(2).to({startPosition:25},0).wait(13));

	// Elephant Head_001
	this.elephant_head = new lib.ElephantHead_001();
	this.elephant_head.parent = this;
	this.elephant_head.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);

	this.elephant_head_1 = new lib.ElephantHead_002();
	this.elephant_head_1.parent = this;
	this.elephant_head_1.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);

	this.elephant_head_2 = new lib.ElephantHead_003();
	this.elephant_head_2.parent = this;
	this.elephant_head_2.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);

	this.elephant_head_3 = new lib.ElephantHead_004();
	this.elephant_head_3.parent = this;
	this.elephant_head_3.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);

	this.elephant_head_4 = new lib.ElephantHead_005();
	this.elephant_head_4.parent = this;
	this.elephant_head_4.setTransform(-254.5,166,1,1,0,0,180,29.1,103.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.elephant_head}]}).to({state:[{t:this.elephant_head_1}]},2).to({state:[{t:this.elephant_head_2}]},1).to({state:[{t:this.elephant_head_3}]},1).to({state:[{t:this.elephant_head_4}]},1).to({state:[{t:this.elephant_head_3}]},21).to({state:[{t:this.elephant_head_2}]},1).to({state:[{t:this.elephant_head_1}]},1).to({state:[{t:this.elephant_head}]},1).to({state:[{t:this.elephant_head}]},9).to({state:[{t:this.elephant_head_1}]},44).to({state:[{t:this.elephant_head_2}]},1).to({state:[{t:this.elephant_head_3}]},1).to({state:[{t:this.elephant_head_4}]},1).to({state:[{t:this.elephant_head_3}]},55).to({state:[{t:this.elephant_head_2}]},1).to({state:[{t:this.elephant_head_1}]},1).to({state:[{t:this.elephant_head}]},1).to({state:[{t:this.elephant_head}]},35).to({state:[{t:this.elephant_head}]},10).to({state:[{t:this.elephant_head}]},12).to({state:[]},4).to({state:[{t:this.elephant_head}]},108).to({state:[]},3).wait(45));
	this.timeline.addTween(cjs.Tween.get(this.elephant_head).to({_off:true},2).wait(27).to({_off:false},0).wait(9).to({_off:true},44).wait(61).to({_off:false},0).wait(57).to({_off:true},4).wait(108).to({_off:false},0).to({_off:true},3).wait(45));

	// Elephant Front Leg
	this.elephant_frontleg = new lib.ElephantFrontLeg();
	this.elephant_frontleg.parent = this;
	this.elephant_frontleg.setTransform(-210.7,174.1,0.7,0.7,0,0,0,69.5,29.9);
	this.elephant_frontleg.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.elephant_frontleg).wait(206).to({scaleY:0.69,skewX:-2.3,x:-215.4,y:175.9},0).wait(2).to({scaleY:0.68,skewX:-4.6,x:-220.1,y:177.9},0).wait(2).to({regX:69.4,scaleY:0.67,skewX:-7.1,x:-224.8,y:179.7},0).wait(6).to({regX:69.5,scaleY:0.68,skewX:-5.5,x:-221.9,y:178.6},0).wait(2).to({scaleY:0.68,skewX:-4.1,x:-219.1,y:177.4},0).wait(2).to({scaleY:0.69,skewX:-2.8,x:-216.2,y:176.3},0).wait(2).to({regY:30,scaleY:0.69,skewX:-1.3,x:-213.4,y:175.2},0).wait(2).to({regY:29.9,scaleY:0.7,skewX:0,x:-210.7,y:174.1},0).wait(18).to({scaleY:0.69,skewX:-2.3,x:-215.4,y:175.9},0).wait(2).to({scaleY:0.68,skewX:-4.6,x:-220.1,y:177.9},0).wait(2).to({regX:69.4,scaleY:0.67,skewX:-7.1,x:-224.8,y:179.7},0).wait(6).to({regX:69.5,scaleY:0.68,skewX:-5.5,x:-221.9,y:178.6},0).wait(2).to({scaleY:0.68,skewX:-4.1,x:-219.1,y:177.4},0).wait(1).to({scaleY:0.69,skewX:-2.8,x:-216.2,y:176.3},0).wait(1).to({regY:30,scaleY:0.69,skewX:-1.3,x:-213.4,y:175.2},0).wait(1).to({regY:29.9,scaleY:0.7,skewX:0,x:-210.7,y:174.1},0).wait(60).to({scaleY:0.69,skewX:-2.3,x:-215.4,y:175.9},0).wait(2).to({scaleY:0.68,skewX:-4.6,x:-220.1,y:177.9},0).wait(2).to({regX:69.4,scaleY:0.67,skewX:-7.1,x:-224.8,y:179.7},0).wait(6).to({regX:69.5,scaleY:0.68,skewX:-5.5,x:-221.9,y:178.6},0).wait(2).to({scaleY:0.68,skewX:-4.1,x:-219.1,y:177.4},0).wait(2).to({scaleY:0.69,skewX:-2.8,x:-216.2,y:176.3},0).wait(2).to({regY:30,scaleY:0.69,skewX:-1.3,x:-213.4,y:175.2},0).wait(2).to({regY:29.9,scaleY:0.7,skewX:0,x:-210.7,y:174.1},0).wait(25));

	// Elephant Hind Leg
	this.elephant_hindleg = new lib.ElephantHindLeg();
	this.elephant_hindleg.parent = this;
	this.elephant_hindleg.setTransform(-110.2,163.6,0.7,0.7,0,0,0,61.6,82.2);
	this.elephant_hindleg.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.elephant_hindleg).wait(206).to({regY:82.1,skewX:-1,x:-112.6},0).wait(2).to({regX:61.5,regY:82.2,skewX:-2,x:-115.1},0).wait(2).to({regX:61.6,scaleY:0.7,skewX:-3.1,x:-117.3},0).wait(6).to({scaleY:0.7,skewX:-2.3,x:-115.9},0).wait(2).to({regY:82.1,skewX:-1.8,x:-114.5},0).wait(2).to({skewX:-1.1,x:-113},0).wait(2).to({regY:82.2,skewX:-0.5,x:-111.6},0).wait(2).to({skewX:0,x:-110.2},0).wait(18).to({regY:82.1,skewX:-1,x:-112.6},0).wait(2).to({regX:61.5,regY:82.2,skewX:-2,x:-115.1},0).wait(2).to({regX:61.6,scaleY:0.7,skewX:-3.1,x:-117.3},0).wait(6).to({scaleY:0.7,skewX:-2.3,x:-115.9},0).wait(2).to({regY:82.1,skewX:-1.8,x:-114.5},0).wait(1).to({skewX:-1.1,x:-113},0).wait(1).to({regY:82.2,skewX:-0.5,x:-111.6},0).wait(1).to({skewX:0,x:-110.2},0).wait(60).to({regY:82.1,skewX:-1,x:-112.6},0).wait(2).to({regX:61.5,regY:82.2,skewX:-2,x:-115.1},0).wait(2).to({regX:61.6,scaleY:0.7,skewX:-3.1,x:-117.3},0).wait(6).to({scaleY:0.7,skewX:-2.3,x:-115.9},0).wait(2).to({regY:82.1,skewX:-1.8,x:-114.5},0).wait(2).to({skewX:-1.1,x:-113},0).wait(2).to({regY:82.2,skewX:-0.5,x:-111.6},0).wait(2).to({skewX:0,x:-110.2},0).wait(25));

	// Elephant Tail
	this.instance_6 = new lib.ElephantTail();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-70.1,114.2,0.7,0.7,0,0,0,8.6,9.6);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,5);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(206).to({regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-75.1,y:113.8},0).wait(2).to({regX:8.5,regY:9.6,rotation:-3.5,x:-80.1,y:113.3},0).wait(2).to({regX:8.6,regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-85,y:112.8},0).wait(6).to({scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-81.9,y:113.1},0).wait(2).to({regY:9.8,rotation:-3.3,x:-79,y:113.4},0).wait(2).to({rotation:-2,x:-76,y:113.8},0).wait(2).to({regY:9.7,rotation:-1,x:-73,y:113.9},0).wait(2).to({regY:9.6,scaleX:0.7,scaleY:0.7,rotation:0,x:-70.1,y:114.2},0).wait(18).to({regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-75.1,y:113.8},0).wait(2).to({regX:8.5,regY:9.6,rotation:-3.5,x:-80.1,y:113.3},0).wait(2).to({regX:8.6,regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-85,y:112.8},0).wait(6).to({scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-81.9,y:113.1},0).wait(2).to({regY:9.8,rotation:-3.3,x:-79,y:113.4},0).wait(1).to({rotation:-2,x:-76,y:113.8},0).wait(1).to({regY:9.7,rotation:-1,x:-73,y:113.9},0).wait(1).to({regY:9.6,scaleX:0.7,scaleY:0.7,rotation:0,x:-70.1,y:114.2},0).wait(60).to({regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-75.1,y:113.8},0).wait(2).to({regX:8.5,regY:9.6,rotation:-3.5,x:-80.1,y:113.3},0).wait(2).to({regX:8.6,regY:9.7,scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-85,y:112.8},0).wait(6).to({scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-81.9,y:113.1},0).wait(2).to({regY:9.8,rotation:-3.3,x:-79,y:113.4},0).wait(2).to({rotation:-2,x:-76,y:113.8},0).wait(2).to({regY:9.7,rotation:-1,x:-73,y:113.9},0).wait(2).to({regY:9.6,scaleX:0.7,scaleY:0.7,rotation:0,x:-70.1,y:114.2},0).wait(25));

	// Elephant Torso
	this.elephant_torso = new lib.ElephantTorso();
	this.elephant_torso.parent = this;
	this.elephant_torso.setTransform(-137.8,156.1,0.7,0.7,0,0,0,210.2,102.3);
	this.elephant_torso.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);

	this.timeline.addTween(cjs.Tween.get(this.elephant_torso).wait(206).to({regY:102.2,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-141.4,y:157.6},0).wait(2).to({regY:102.4,rotation:-3.5,x:-145,y:159.4},0).wait(2).to({scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-148.5,y:161},0).wait(6).to({regX:210.1,scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-146.4,y:160},0).wait(2).to({regX:210.2,regY:102.3,rotation:-3.3,x:-144.2,y:158.9},0).wait(2).to({regY:102.4,rotation:-2,x:-142.1,y:158},0).wait(2).to({regY:102.2,rotation:-1,x:-139.9,y:157},0).wait(2).to({regY:102.3,scaleX:0.7,scaleY:0.7,rotation:0,x:-137.8,y:156.1},0).wait(18).to({regY:102.2,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-141.4,y:157.6},0).wait(2).to({regY:102.4,rotation:-3.5,x:-145,y:159.4},0).wait(2).to({scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-148.5,y:161},0).wait(6).to({regX:210.1,scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-146.4,y:160},0).wait(2).to({regX:210.2,regY:102.3,rotation:-3.3,x:-144.2,y:158.9},0).wait(1).to({regY:102.4,rotation:-2,x:-142.1,y:158},0).wait(1).to({regY:102.2,rotation:-1,x:-139.9,y:157},0).wait(1).to({regY:102.3,scaleX:0.7,scaleY:0.7,rotation:0,x:-137.8,y:156.1},0).wait(60).to({regY:102.2,scaleX:0.7,scaleY:0.7,rotation:-1.8,x:-141.4,y:157.6},0).wait(2).to({regY:102.4,rotation:-3.5,x:-145,y:159.4},0).wait(2).to({scaleX:0.7,scaleY:0.7,rotation:-5.4,x:-148.5,y:161},0).wait(6).to({regX:210.1,scaleX:0.7,scaleY:0.7,rotation:-4.3,x:-146.4,y:160},0).wait(2).to({regX:210.2,regY:102.3,rotation:-3.3,x:-144.2,y:158.9},0).wait(2).to({regY:102.4,rotation:-2,x:-142.1,y:158},0).wait(2).to({regY:102.2,rotation:-1,x:-139.9,y:157},0).wait(2).to({regY:102.3,scaleX:0.7,scaleY:0.7,rotation:0,x:-137.8,y:156.1},0).wait(25));

	// Elephant Front Leg Back
	this.elephant_frontlegback = new lib.ElephantFrontLegBack();
	this.elephant_frontlegback.parent = this;
	this.elephant_frontlegback.setTransform(-213.3,164.9,0.7,0.7,0,0,0,27.1,34.6);

	this.timeline.addTween(cjs.Tween.get(this.elephant_frontlegback).wait(206).to({scaleY:0.69,skewX:-2.3,x:-218.3,y:166.9},0).wait(2).to({regY:34.7,scaleY:0.68,skewX:-4.6,x:-223.3,y:169},0).wait(2).to({regX:27.2,regY:34.6,scaleY:0.67,skewX:-7.1,x:-228.3,y:170.9},0).wait(6).to({regX:26.9,scaleY:0.68,skewX:-5.5,x:-225.5,y:169.7},0).wait(2).to({regX:27.1,scaleY:0.68,skewX:-4.1,x:-222.4,y:168.6},0).wait(2).to({regX:27.2,scaleY:0.69,skewX:-2.8,x:-219.2,y:167.4},0).wait(2).to({regX:27.1,scaleY:0.69,skewX:-1.3,x:-216.3,y:166.1},0).wait(2).to({scaleY:0.7,skewX:0,x:-213.3,y:164.9},0).wait(18).to({scaleY:0.69,skewX:-2.3,x:-218.3,y:166.9},0).wait(2).to({regY:34.7,scaleY:0.68,skewX:-4.6,x:-223.3,y:169},0).wait(2).to({regX:27.2,regY:34.6,scaleY:0.67,skewX:-7.1,x:-228.3,y:170.9},0).wait(6).to({regX:26.9,scaleY:0.68,skewX:-5.5,x:-225.5,y:169.7},0).wait(2).to({regX:27.1,scaleY:0.68,skewX:-4.1,x:-222.4,y:168.6},0).wait(1).to({regX:27.2,scaleY:0.69,skewX:-2.8,x:-219.2,y:167.4},0).wait(1).to({regX:27.1,scaleY:0.69,skewX:-1.3,x:-216.3,y:166.1},0).wait(1).to({scaleY:0.7,skewX:0,x:-213.3,y:164.9},0).wait(60).to({scaleY:0.69,skewX:-2.3,x:-218.3,y:166.9},0).wait(2).to({regY:34.7,scaleY:0.68,skewX:-4.6,x:-223.3,y:169},0).wait(2).to({regX:27.2,regY:34.6,scaleY:0.67,skewX:-7.1,x:-228.3,y:170.9},0).wait(6).to({regX:26.9,scaleY:0.68,skewX:-5.5,x:-225.5,y:169.7},0).wait(2).to({regX:27.1,scaleY:0.68,skewX:-4.1,x:-222.4,y:168.6},0).wait(2).to({regX:27.2,scaleY:0.69,skewX:-2.8,x:-219.2,y:167.4},0).wait(2).to({regX:27.1,scaleY:0.69,skewX:-1.3,x:-216.3,y:166.1},0).wait(2).to({scaleY:0.7,skewX:0,x:-213.3,y:164.9},0).wait(25));

	// Elephant Hind Leg Back
	this.elephant_hindlegback = new lib.ElephantHindLegBack();
	this.elephant_hindlegback.parent = this;
	this.elephant_hindlegback.setTransform(-113.3,161.4,0.7,0.7,0,0,0,76.8,59.2);

	this.timeline.addTween(cjs.Tween.get(this.elephant_hindlegback).wait(206).to({skewX:-1,x:-115.6,y:161.5},0).wait(2).to({skewX:-2,x:-118,y:161.4},0).wait(2).to({scaleY:0.7,skewX:-3.1,x:-120.4},0).wait(6).to({regY:59.3,scaleY:0.7,skewX:-2.3,x:-119.1,y:161.5},0).wait(2).to({regX:76.7,regY:59.2,skewX:-1.8,x:-117.6,y:161.4},0).wait(2).to({regX:76.8,skewX:-1.1,x:-116.2},0).wait(2).to({regX:76.9,regY:59.3,skewX:-0.5,x:-114.6,y:161.5},0).wait(2).to({regX:76.8,regY:59.2,skewX:0,x:-113.3,y:161.4},0).wait(18).to({skewX:-1,x:-115.6,y:161.5},0).wait(2).to({skewX:-2,x:-118,y:161.4},0).wait(2).to({scaleY:0.7,skewX:-3.1,x:-120.4},0).wait(6).to({regY:59.3,scaleY:0.7,skewX:-2.3,x:-119.1,y:161.5},0).wait(2).to({regX:76.7,regY:59.2,skewX:-1.8,x:-117.6,y:161.4},0).wait(1).to({regX:76.8,skewX:-1.1,x:-116.2},0).wait(1).to({regX:76.9,regY:59.3,skewX:-0.5,x:-114.6,y:161.5},0).wait(1).to({regX:76.8,regY:59.2,skewX:0,x:-113.3,y:161.4},0).wait(60).to({skewX:-1,x:-115.6,y:161.5},0).wait(2).to({skewX:-2,x:-118,y:161.4},0).wait(2).to({scaleY:0.7,skewX:-3.1,x:-120.4},0).wait(6).to({regY:59.3,scaleY:0.7,skewX:-2.3,x:-119.1,y:161.5},0).wait(2).to({regX:76.7,regY:59.2,skewX:-1.8,x:-117.6,y:161.4},0).wait(2).to({regX:76.8,skewX:-1.1,x:-116.2},0).wait(2).to({regX:76.9,regY:59.3,skewX:-0.5,x:-114.6,y:161.5},0).wait(2).to({regX:76.8,regY:59.2,skewX:0,x:-113.3,y:161.4},0).wait(25));

	// Layer 9
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#64928F").s().p("AADgGIABAAIgHANIAGgNg");
	this.shape.setTransform(255.4,237.3);

	this.instance_7 = new lib.Tween7gfgf9("synched",0);
	this.instance_7.parent = this;
	this.instance_7.setTransform(255.4,237.3);
	this.instance_7._off = true;

	this.instance_8 = new lib.Tween80dsvcr("synched",0);
	this.instance_8.parent = this;
	this.instance_8.setTransform(255.4,237.3);
	this.instance_8._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(200).to({_off:true},4).wait(108).to({_off:false},0).to({_off:true},3).wait(45));
	this.timeline.addTween(cjs.Tween.get(this.instance_7).wait(204).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).to({_off:true},2).wait(14).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).to({_off:true},2).wait(11).to({_off:false},0).to({_off:true},55).wait(3).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).to({_off:true},2).wait(14).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(13));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(210).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).to({_off:true},2).wait(22).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(1).to({startPosition:0},0).wait(1).to({startPosition:0},0).to({_off:true},1).wait(64).to({_off:false},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).wait(2).to({startPosition:0},0).to({_off:true},2).wait(25));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-353.9,54.8,609.8,258.3);


(lib.elephant = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// earGlow
	this.earGlow = new lib.earGlow();
	this.earGlow.parent = this;
	this.earGlow.setTransform(191.4,114.4,1.018,0.998,0,0,0,31.6,55.6);
	this.earGlow.alpha = 0;
	this.earGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.earGlow.cache(-5,-5,73,123);

	this.timeline.addTween(cjs.Tween.get(this.earGlow).wait(1));

	// trunkGlow
	this.trunkGlow = new lib.elephant_trunkGlow();
	this.trunkGlow.parent = this;
	this.trunkGlow.setTransform(148.5,192.5,1,1,0,0,0,37.8,45.1);
	this.trunkGlow.alpha = 0;
	this.trunkGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.trunkGlow.cache(-5,-5,86,100);

	this.timeline.addTween(cjs.Tween.get(this.trunkGlow).wait(1));

	// backGlow
	this.backGlow = new lib.elephant_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(297.8,108.3,0.997,1.007,0,-5.6,0.9,75.2,31.8);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.backGlow.cache(-5,-5,155,68);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// footGlow
	this.footGlow = new lib.elephant_footGlow();
	this.footGlow.parent = this;
	this.footGlow.setTransform(204.1,253.6,1,1,0,0,0,16.8,18.2);
	this.footGlow.alpha = 0;
	this.footGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.footGlow.cache(-4,-7,182,50);

	this.timeline.addTween(cjs.Tween.get(this.footGlow).wait(1));

	// legGlow
	this.legGlow = new lib.legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(327.4,191.5,1,1,0,0,0,37.8,82.5);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(3, 3, 1)];
	this.legGlow.cache(-107,-5,188,175);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// Layer 2
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(226.5,206.2,1.761,1.1,-89.6);

	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(328.3,183.2,2.698,1.517,-91.4);

	this.tummy = new lib.invisiblebox();
	this.tummy.parent = this;
	this.tummy.setTransform(272.3,178,1.457,1.042,-90.1);

	this.foot3 = new lib.invisiblebox();
	this.foot3.parent = this;
	this.foot3.setTransform(334.5,259.4,0.812,1.361,-89.6);

	this.foot1 = new lib.invisiblebox();
	this.foot1.parent = this;
	this.foot1.setTransform(219.8,258.9,0.699,1.847,-89.6);

	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(377.7,164.5,2.684,0.469,-89.9);

	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(294.6,99.8,3.404,1.212,0.6);

	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(195.3,114.5,1.314,2.734,-2.5);

	this.mouth = new lib.invisiblebox();
	this.mouth.parent = this;
	this.mouth.setTransform(147.7,167,0.966,0.874,-13.2);

	this.trunk = new lib.invisiblebox();
	this.trunk.parent = this;
	this.trunk.setTransform(145.1,217.5,2.072,1.291,-0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.trunk},{t:this.mouth},{t:this.ear},{t:this.back},{t:this.tail},{t:this.foot1},{t:this.foot3},{t:this.tummy},{t:this.leg1},{t:this.leg2}]}).wait(1));

	// main
	this.main = new lib.Elephant();
	this.main.parent = this;
	this.main.setTransform(227.6,182.9,0.947,0.947,0,0,180,206.3,198.7);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.elephant, new cjs.Rectangle(102.4,46.1,655.6,246.7), null);


// stage content:
(lib.MWelephant = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Elephant();
	this.instance.parent = this;
	this.instance.setTransform(445,203.1,1,1,0,0,0,-49.1,182.9);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(440.2,228.4,609.8,259.3);
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWelephant_atlas_.png?1528313453439", id:"MWelephant_atlas_"}
	],
	preloads: []
};




})(lib_Elephant = lib_Elephant||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Elephant, images, createjs, ss, AdobeAn;